function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "SVGID_1_",
  x: -410,
  y: -501,
  width: 1920,
  height: 1080
}));

var _ref3 = /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_2_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_1_",
  overflow: "visible"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "SVGID_3_",
  points: "420.181,10.602 431.415,21.833 408.951,21.833 420.181,10.602 408.951,-0.633 397.715,10.602          408.951,21.835 408.951,44.303 431.417,44.303 431.417,21.835 442.65,10.602 431.417,-0.633      "
}));

var _ref5 = /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_4_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_3_",
  overflow: "visible"
}));

var _ref6 = /*#__PURE__*/React.createElement("polygon", {
  clipPath: "url(#SVGID_4_)",
  fill: "url(#SVGID_5_)",
  points: "420.183,-23.101 375.247,21.835 420.183,66.771        465.118,21.835    "
});

var _ref7 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#SVGID_2_)"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "SVGID_6_",
  x: -410,
  y: -501,
  width: 1920,
  height: 1080
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_7_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_6_",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#SVGID_7_)",
  fill: "#4D4D4F",
  d: "M449.166,61.623c0,0-0.874-0.87-2.062-0.87c-1.135,0-2.063,0.38-2.063,1.92       v9.526h-3.014v-9.526c0-3.045,1.874-4.847,4.819-4.847c0.965,0,2.298,0.337,2.875,0.856c0.435,0.396,0.401,1.058,0.117,1.74       C449.684,60.789,449.328,61.38,449.166,61.623"
}), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#SVGID_7_)",
  fill: "#4D4D4F",
  d: "M381.702,52.087c-1.016,0-1.838,0.842-1.838,1.881       c0,1.035,0.822,1.878,1.838,1.878c1.014,0,1.835-0.843,1.835-1.878C383.537,52.929,382.716,52.087,381.702,52.087"
}), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#SVGID_7_)",
  fill: "#4D4D4F",
  d: "M380.294,58.027v12.221c0,1.934,1.553,2.304,3.012,2.06V60.084       C383.306,58.152,381.755,57.779,380.294,58.027"
}), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#SVGID_7_)",
  fill: "#4D4D4F",
  d: "M432.573,57.826c-4.325,0-6.6,3.313-6.6,7.4s2.275,7.404,6.6,7.404       c4.324,0,6.601-3.317,6.601-7.404S436.897,57.826,432.573,57.826 M432.573,69.962c-2.571,0-3.458-2.12-3.458-4.735       s0.887-4.731,3.458-4.731c2.574,0,3.458,2.116,3.458,4.731S435.147,69.962,432.573,69.962"
}), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#SVGID_7_)",
  fill: "#4D4D4F",
  d: "M371.514,57.826c-2.437,0-3.494,1.027-3.836,1.35       c-0.641-1.51-2.822-1.06-2.822-1.06V78.4h3.015v-6.861c0.208,0.167,0.923,1.092,3.358,1.092c0.678,0,6.083,0,6.083-7.629       C377.312,57.386,371.514,57.826,371.514,57.826 M370.827,69.962c-1.811,0-2.858-1.271-2.956-1.389v-6.441       c0-0.437,0.252-0.807,0.769-1.139c0.554-0.353,1.271-0.529,2.129-0.529c0.636,0,3.357-0.019,3.357,4.681       C374.125,66.741,373.91,69.962,370.827,69.962"
}), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#SVGID_7_)",
  fill: "#4D4D4F",
  d: "M420.359,59.181c-0.344-0.323-1.401-1.354-3.839-1.354       c0,0-5.798-0.439-5.798,7.179c0,7.628,5.407,7.628,6.085,7.628c2.433,0,3.147-0.926,3.357-1.094c0,2.016-0.328,2.646-0.602,3.079       c-0.264,0.42-0.651,0.752-1.143,0.985c-0.503,0.237-1.199,0.357-2.07,0.357c-2.657,0-4.012-1.759-4.012-1.759       s-1.241,1.216-1.241,2.046c0,1.268,2.14,2.385,5.253,2.385c3.58,0,4.889-1.393,5.416-2.063c0.523-0.662,1.412-2.015,1.412-5.603       V58.12C423.178,58.12,420.997,57.67,420.359,59.181 M420.165,68.576c-0.099,0.119-1.146,1.39-2.954,1.39       c-3.089,0-3.302-3.223-3.302-4.821c0-4.696,2.722-4.678,3.36-4.678c0.857,0,1.573,0.18,2.125,0.533       c0.52,0.327,0.771,0.698,0.771,1.132V68.576z"
}), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#SVGID_7_)",
  fill: "#4D4D4F",
  d: "M391.197,72.631c2.298,0,3.873-1.114,3.873-2.027       c0-0.843-0.764-1.693-1.142-2.072c0,0-0.937,1.431-2.358,1.431c-0.678,0-1.58-0.211-1.58-2.063v-7.116h2.641       c1.697,0,2.02-1.358,1.806-2.642h-0.009h-4.438l-0.001-2.037c0-1.938-1.552-2.303-3.012-2.059v13.682       C386.978,69.231,386.978,72.631,391.197,72.631"
}), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#SVGID_7_)",
  fill: "#4D4D4F",
  d: "M407.845,60.88c-0.174-0.678-0.79-3.054-5.139-3.054       c-2.835,0-4.406,0.951-4.731,1.182c-0.384,0.28-0.579,0.594-0.579,0.938c0,0.207,0.029,0.48,0.176,0.79       c0.303,0.638,0.763,0.993,0.763,0.993s1.96-1.233,4.083-1.233c1.077,0,1.799,0.195,2.156,0.577       c0.586,0.628,0.541,1.898,0.541,1.898c-0.1-0.009-0.205-0.009-0.315-0.009c0,0-8.263-0.459-8.263,5.191       c0,0.846,0.143,1.562,0.431,2.113c0.285,0.552,1.161,2.192,4.159,2.192c2.745,0,3.773-1.107,4.191-1.465       c0.34,0.995,1.066,1.637,2.781,1.31v-9.171C408.099,62.29,408.015,61.533,407.845,60.88 M405.144,68.04       c-0.076,1.614-5.597,3.246-5.597-0.029c0-3.006,5.597-2.608,5.597-2.608V68.04z"
}), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#SVGID_7_)",
  fill: "#4D4D4F",
  d: "M462.404,60.88c-0.174-0.678-0.791-3.054-5.14-3.054       c-2.833,0-4.403,0.951-4.731,1.182c-0.384,0.28-0.58,0.594-0.58,0.938c0,0.207,0.029,0.48,0.177,0.79       c0.303,0.638,0.764,0.993,0.764,0.993s1.962-1.233,4.082-1.233c1.079,0,1.798,0.195,2.156,0.577       c0.588,0.628,0.542,1.898,0.542,1.898c-0.1-0.009-0.205-0.009-0.315-0.009c0,0-8.262-0.459-8.262,5.191       c0,0.846,0.141,1.562,0.43,2.113c0.289,0.552,1.16,2.192,4.157,2.192c2.745,0,3.775-1.107,4.192-1.465       c0.343,0.995,1.067,1.637,2.781,1.31v-9.171C462.657,62.29,462.573,61.533,462.404,60.88 M459.701,68.04       c-0.072,1.614-5.595,3.246-5.595-0.029c0-3.006,5.595-2.608,5.595-2.608V68.04z"
}), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#SVGID_7_)",
  fill: "#4D4D4F",
  d: "M475.51,68.07c0,0.752-0.134,1.433-0.464,1.984       c-1.526,2.549-4.365,2.549-5.073,2.549c-2.861,0-4.146-0.989-4.371-1.225c-0.24-0.253-0.363-0.529-0.363-0.812       c0-0.8,0.934-2.136,0.934-2.136s1.606,1.617,3.884,1.617c2.435,0,2.47-1.437,2.47-1.778c0-0.344-0.078-0.619-0.212-0.833       c-0.351-0.554-0.889-0.778-1.492-0.943c-0.607-0.163-2.984-0.524-4.113-1.5c-0.406-0.349-0.765-0.74-1.024-1.222       c-0.261-0.49-0.391-1.101-0.391-1.816c0-1.825,1.122-2.78,1.617-3.121c0.482-0.331,1.681-1.009,3.548-1.009       c1.914,0,3.205,0.592,3.588,0.813c0.415,0.227,1.118,0.659,1.118,1.368c0,1.058-1.011,1.846-1.011,1.846s-1.467-1.473-3.637-1.473       c-0.232,0-2.268-0.008-2.268,1.433c0,0.249,0.055,0.45,0.165,0.612c0.119,0.172,0.291,0.33,0.514,0.461       c0.234,0.141,0.518,0.261,0.838,0.358c0.34,0.107,0.712,0.202,1.104,0.298c0.583,0.136,1.154,0.311,1.697,0.513       C475.51,65.141,475.51,67.319,475.51,68.07"
}), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#SVGID_7_)",
  fill: "#4D4D4F",
  d: "M400.664,56.072c0,0,2.356-3.083,2.586-3.386       c0.109-0.135,0.737-1.114,1.75-1.114c1.007,0,2.054,0.942,2.054,0.942l-3.107,3.354c-0.241,0.241-0.752,0.896-1.671,0.896       C401.453,56.766,400.664,56.072,400.664,56.072"
}));

var _ref8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_8_",
  d: "M993.509,25.471c2.462,8.719-1.164,14.542-8.37,14.356c-6.144-0.158-6.385-4.119-6.103-5.08         c0.659-2.247,2.347-2.012,3.217-1.459c1.661-2.209-1.188-4.588-4.179-4.16c-3.559,0.507-5.908,5.201-4.808,9.702         c1.458,5.961,8.554,9.699,14.585,9.292c10.644-0.717,13.34-9.51,13.611-11.632c2.055-16.13-13.661-19.301-10.771-30.69         C984.542,11.973,991.009,16.622,993.509,25.471"
}));

var _ref9 = /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_9_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_8_",
  overflow: "visible"
}));

var _ref10 = /*#__PURE__*/React.createElement("polygon", {
  clipPath: "url(#SVGID_9_)",
  fill: "url(#SVGID_10_)",
  points: "987.842,64.205 1024.883,27.165 987.842,-9.876        950.802,27.165    "
});

var _ref11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "SVGID_11_",
  x: -410,
  y: -501,
  width: 1920,
  height: 1080
}));

var _ref12 = /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_12_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_11_",
  overflow: "visible"
}));

var _ref13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "SVGID_13_",
  x: 977,
  y: 27.909,
  width: 20.561,
  height: 18.163
}));

var _ref14 = /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_14_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_13_",
  overflow: "visible"
}));

var _ref15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_15_",
  d: "M986.249,41.246c-5.09-0.562-9.043-4.98-6.619-7.713c0.006,0.009,0.009,0.018,0.012,0.025               c0.798-0.925,1.942-0.694,2.611-0.27c-1.397-1.888-4.998-0.637-5.057,2.969v0.178c0.001,0.069,0.004,0.14,0.007,0.212               c0.17,3.222,2.849,8.198,9.447,8.747c8.134,0.679,10.423-5.194,10.46-10.483v-0.265c-0.02-2.805-0.661-5.411-1.38-6.736               C997.557,38.627,990.676,41.735,986.249,41.246"
}));

var _ref16 = /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_16_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_15_",
  overflow: "visible"
}));

var _ref17 = /*#__PURE__*/React.createElement("rect", {
  x: 977.196,
  y: 27.909,
  clipPath: "url(#SVGID_16_)",
  fill: "url(#SVGID_17_)",
  width: 20.36,
  height: 18.163
});

var _ref18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_18_",
  d: "M978.443,47.481c-0.251-0.137-0.085,2.605,0.337,3.38c0.361,0.658,4.854,1.883,9.958,1.281         c6.712-0.792,10.247-5.196,11.068-6.982c0.371-0.801,0-1.521,0-1.521C992.157,52.481,981.445,49.151,978.443,47.481"
}));

var _ref19 = /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_19_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_18_",
  overflow: "visible"
}));

var _ref20 = /*#__PURE__*/React.createElement("rect", {
  x: 978.192,
  y: 43.64,
  clipPath: "url(#SVGID_19_)",
  fill: "url(#SVGID_20_)",
  width: 21.985,
  height: 9.104
});

var _ref21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_21_",
  d: "M991.448,1.001c-0.006,0-0.009,0-0.015,0.005c-0.006,0-0.012,0-0.014,0.004         c-9.773,1.435-14.855,10.184-12.748,17.515c2.1,7.339,7.495,9.86,5.833,14.635c-0.795,2.324-4.009,2.286-4.784,0.373         c-2.422,2.733,1.174,6.955,6.183,8.023c0.5,0.105,1.057,0.15,1.644,0.133c4.65-0.127,11.169-4.236,8.272-13.781         c-0.069-0.229-0.143-0.451-0.219-0.675c-0.004,0-0.004-0.004-0.004-0.009c-0.023-0.079-0.051-0.154-0.081-0.227         c-2.123-5.96-6.573-9.7-8.096-14.035c-0.006-0.009-0.009-0.024-0.013-0.035c-0.322-0.909-0.513-1.85-0.522-2.837         c-0.024-2.454,0.992-6.138,4.669-9.103C991.518,0.992,991.484,0.996,991.448,1.001"
}));

var _ref22 = /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_22_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_21_",
  overflow: "visible"
}));

var _ref23 = /*#__PURE__*/React.createElement("polygon", {
  clipPath: "url(#SVGID_22_)",
  fill: "url(#SVGID_23_)",
  points: "987.641,52.782 1019.076,21.347 987.641,-10.088        956.205,21.347    "
});

var _ref24 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#SVGID_2_)"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "SVGID_24_",
  x: -410,
  y: -501,
  width: 1920,
  height: 1080
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_25_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_24_",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#SVGID_25_)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "SVGID_26_",
  x: 984.84,
  y: 0.988,
  width: 11.7,
  height: 40.703
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_27_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_26_",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#SVGID_27_)"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "SVGID_28_",
  x: 984.837,
  y: 0.987,
  width: 11.699,
  height: 40.703
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_29_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_28_",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#SVGID_29_)",
  fill: "#FFFFFF",
  d: "M987.546,41.689c-0.587-0.041-0.946-0.097-0.969-0.097             c3.998-2.006,5.713-5.859,5.713-10.49c0-9.461-7.654-13.697-7.449-20.604c0.103-3.277,2.475-7.887,6.58-9.488             c0.002-0.005,0.007-0.005,0.013-0.005c0.012-0.009,0.028-0.014,0.037-0.018c-0.005,0.004-0.014,0.009-0.025,0.014             c-3.658,2.97-4.645,6.644-4.645,9.089c0,0.982,0.227,1.917,0.605,2.836c0.005,0.013,0.008,0.026,0.014,0.036             c1.521,4.334,5.974,8.074,8.096,14.034c0.021,0.069,0.044,0.149,0.08,0.228c0,0.005,0,0.008,0.006,0.008             c0.075,0.225,0.148,0.447,0.217,0.676C998.718,37.454,992.198,41.563,987.546,41.689"
})))), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#SVGID_25_)",
  fill: "#4D4D4F",
  d: "M976.364,76.334V70.36c0-2.08-0.956-3.506-2.804-3.506       c-1.853,0-2.804,1.426-2.804,3.506v5.974c0,1.861-1.499,2.219-2.909,1.985V70.36c0-3.47,1.594-6.106,5.713-6.106       c4.113,0,5.707,2.637,5.707,6.106v7.959C977.862,78.553,976.364,78.195,976.364,76.334"
}), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#SVGID_25_)",
  fill: "#4D4D4F",
  d: "M984.273,58.835c-0.979,0-1.772,0.815-1.772,1.813s0.794,1.807,1.772,1.807       c0.977,0,1.771-0.81,1.771-1.807S985.25,58.835,984.273,58.835"
}), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#SVGID_25_)",
  fill: "#4D4D4F",
  d: "M982.919,64.56v11.774c0,1.861,1.496,2.219,2.899,1.982V66.539       C985.818,64.676,984.322,64.323,982.919,64.56"
}), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#SVGID_25_)",
  fill: "#4D4D4F",
  d: "M997.773,78.217v-7.853c0-2.089-0.958-3.509-2.804-3.509       c-1.854,0-2.807,1.42-2.807,3.509v5.97c0,1.861-1.496,2.219-2.905,1.984v-7.954c0-3.474,1.598-6.11,5.712-6.11       c1.904,0,3.261,0.568,4.178,1.526c0.918-0.895,2.321-1.526,4.337-1.526c4.114,0,5.707,2.637,5.707,6.11v7.954       c-1.411,0.234-2.902-0.123-2.902-1.984v-5.97c0-2.089-0.957-3.509-2.805-3.509c-1.852,0-2.811,1.42-2.811,3.509v7.853H997.773z"
}), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#SVGID_25_)",
  fill: "#4D4D4F",
  d: "M1014.77,69.837c0.103-0.893,0.701-2.983,3.1-2.983       c2.784,0,2.77,2.614,2.784,2.983H1014.77z M1014.761,72.163h8.676c0,0,1.413-7.8-5.46-7.8c-6.553,0-6.222,7.087-6.222,7.087       c0,5.075,2.855,7.183,6.833,7.183c2.687,0,4.652-1.351,4.652-2.229c0-0.811-0.873-1.636-1.243-1.996       c-0.314,0.446-1.572,1.675-3.503,1.675C1015.313,76.083,1014.761,73.242,1014.761,72.163"
}), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#SVGID_25_)",
  fill: "#4D4D4F",
  d: "M955.78,66.553v5.972c0,2.082,0.957,3.507,2.804,3.507       c1.851,0,2.807-1.425,2.807-3.507v-5.972c0-1.863,1.496-2.219,2.906-1.985v7.957c0,3.472-1.599,6.108-5.713,6.108       c-4.113,0-5.707-2.637-5.707-6.108v-7.957C954.285,64.334,955.78,64.689,955.78,66.553"
}));

var _ref25 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_30_",
  d: "M981.431,32.869c-0.015-0.003-0.03-0.006-0.045-0.009C981.4,32.863,981.416,32.866,981.431,32.869          M981.386,32.86c-0.015-0.003-0.03-0.005-0.046-0.008C981.355,32.855,981.37,32.857,981.386,32.86 M979.631,33.461l0.001,0.009         c0.405-0.47,0.903-0.644,1.377-0.644c0.113,0,0.224,0.008,0.331,0.026c-0.111-0.019-0.224-0.03-0.338-0.03         C980.527,32.822,980.033,32.993,979.631,33.461"
}));

var _ref26 = /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_31_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_30_",
  overflow: "visible"
}));

var _ref27 = /*#__PURE__*/React.createElement("rect", {
  x: 979.631,
  y: 32.822,
  clipPath: "url(#SVGID_31_)",
  fill: "url(#SVGID_32_)",
  width: 1.8,
  height: 0.647
});

var _ref28 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#SVGID_2_)"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "SVGID_33_",
  x: -410,
  y: -501,
  width: 1920,
  height: 1080
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_34_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_33_",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#SVGID_34_)",
  fill: "#F16522",
  d: "M52.044,30.421c-4.187,1.613-6.128,2.748-6.128,2.748       c-0.471,0.246-1.064,0.828-1.318,1.295l-3.202,5.869c-0.254,0.467-0.048,0.715,0.457,0.553c0,0,1.286-0.416,2.533-0.785       c3.029-0.896,8.629-2.228,8.629-2.228c0.516-0.121,1.147-0.603,1.402-1.07l4.409-8.082c0.255-0.467,0.051-0.713-0.454-0.547       C58.372,28.173,55.232,29.191,52.044,30.421"
}), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#SVGID_34_)",
  fill: "#F16522",
  d: "M80.486,33.9c0.529-0.043,0.754-0.459,0.5-0.926l-4.222-7.74       c-0.255-0.467-0.893-0.785-1.418-0.705l-8.46,1.445c-0.52,0.104-0.738,0.571-0.484,1.035l3.809,6.983       c0.254,0.467,0.895,0.808,1.423,0.758L80.486,33.9z"
}), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#SVGID_34_)",
  fill: "#F37920",
  d: "M74.744,21.531l-0.771-1.412L72.491,17.4l-1.985-3.64       c-0.255-0.467-0.872-0.7-1.37-0.518c-5.784,1.693-11.504,4.303-14.222,6.117c-1.505,1.006-2.814,2.094-2.814,2.094       c-0.408,0.34-0.95,1-1.205,1.467l-3.559,6.525c-0.254,0.467-0.07,0.664,0.413,0.44c0,0,0.924-0.43,1.96-0.87       c3.514-1.49,7.359-2.797,11.431-3.882c0.078-0.022,0.156-0.041,0.233-0.063c4.504-1.17,12.88-2.535,12.88-2.535       C74.777,22.449,74.999,21.998,74.744,21.531"
}), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#SVGID_34_)",
  fill: "#F6921E",
  d: "M54.676,17.019c0,0,4.015-2.383,6.737-3.523       c2.394-1.004,6.648-2.247,6.648-2.247c0.511-0.148,0.719-0.652,0.466-1.119l-3.943-7.224c-0.814-1.323-2.071-1.271-2.85,0.158       l-0.01,0.008l-7.416,13.593C54.054,17.13,54.22,17.29,54.676,17.019"
}), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#SVGID_34_)",
  fill: "#EF4E23",
  d: "M87.584,45.069l-4.548-8.337c-0.254-0.467-0.761-0.83-1.124-0.809       l-0.337,0.023c-16.843,1.166-29.144,3.998-36.498,6.17c-2.181,0.645-4.743,1.527-4.743,1.527c-0.503,0.172-0.86,0.268-1.377,1.16       c0,0-0.039,0.072-0.136,0.252l0.003,0.006c-0.638,1.391,0.092,2.492,1.703,2.492l0.081,0.01h45.273       C87.493,47.563,88.222,46.458,87.584,45.069"
}), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#SVGID_34_)",
  fill: "#58595B",
  d: "M14.346,66.921H8.798L7.54,71.478c-0.096,0.307-0.192,0.446-1.225,0.446       c-0.355,0-1.032-0.03-1.646-0.085l5.742-19.115c0.065-0.279,0.42-0.391,1-0.391c0.452,0,0.903,0.029,1.226,0.084l5.774,19.033       c0.064,0.308-0.097,0.474-1.128,0.474c-0.388,0-0.904,0-1.549-0.058L14.346,66.921z M9.347,64.864h4.451l-1.097-3.945       c-0.515-1.834-0.967-4.002-1.128-5.334c-0.194,1.332-0.645,3.473-1.128,5.334L9.347,64.864z"
}), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#SVGID_34_)",
  fill: "#58595B",
  d: "M19.733,58.64c1.258-0.471,3.387-0.943,5.096-0.943       c3.386,0,4.548,1.027,4.548,3.723v10.002c0,0.445-0.064,0.445-2.709,0.445v-9.781c0-1.75-0.323-2.416-1.936-2.416       c-0.677,0-1.677,0.166-2.387,0.5v11.252c0,0.445-0.064,0.445-2.612,0.445V58.64z"
}), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#SVGID_34_)",
  fill: "#58595B",
  d: "M31.732,52.474c0-1.029,0.451-1.029,2.612-1.029v7.334       c1-0.75,2.387-1.082,3.613-1.082c2.774,0,3.355,1.334,3.355,3.668v10.057c0,0.445-0.129,0.445-2.71,0.445v-9.863       c0-1.223-0.259-2.223-1.839-2.223c-0.709,0-1.645,0.193-2.419,0.777v10.863c0,0.445-0.032,0.445-2.612,0.445V52.474z"
}), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#SVGID_34_)",
  fill: "#58595B",
  d: "M43.537,58.446c0.548-0.307,2.451-0.75,4.902-0.75c2.775,0,4,0.889,4,3.391       v1.471c0,3.197-0.032,6.531-0.193,8.643c-0.871,0.445-2.387,0.945-4.484,0.945c-2.354,0.027-4.613-0.418-4.613-4.225       c0-3.861,2.129-4.557,4.291-4.557c0.709,0,1.71,0.084,2.355,0.361V61.53c0-1.305-0.71-1.639-2-1.639       c-1.613,0-3.323,0.277-4.258,0.611c-0.29-0.445-0.355-0.945-0.355-1.277C43.182,58.919,43.279,58.612,43.537,58.446 M48.278,65.06       c-1.29,0-2.387,0.389-2.387,2.807c0,2.027,0.839,2.389,2.098,2.389c0.708,0,1.418-0.223,1.709-0.473       c0.097-0.916,0.097-2.973,0.097-4.473C49.375,65.142,48.73,65.06,48.278,65.06"
}), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#SVGID_34_)",
  fill: "#58595B",
  d: "M54.762,58.642c1.258-0.473,3.387-0.945,5.097-0.945       c3.386,0,4.548,1.027,4.548,3.723v10.002c0,0.445-0.065,0.445-2.71,0.445v-9.781c0-1.75-0.323-2.416-1.936-2.416       c-0.677,0-1.677,0.166-2.387,0.5v11.252c0,0.445-0.064,0.445-2.612,0.445V58.642z"
}), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#SVGID_34_)",
  fill: "#58595B",
  d: "M88.727,71.144c-1.226,0.584-3.064,1.002-4.806,1.002       c-3.839,0-4.839-1.5-4.839-4.613v-9.086c0-0.473,0-0.473,2.71-0.473v9.754c0,1.805,0.419,2.443,2.162,2.443       c0.58,0,1.483-0.109,2.161-0.498V58.446c0-0.473,0.032-0.473,2.612-0.473V71.144z"
}), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#SVGID_34_)",
  fill: "#58595B",
  d: "M100.725,62.169c0,1.223-0.096,2.613-0.354,3.613       c-2.226,0.361-5.193,0.443-6.742,0.443c0.13,2.945,1.032,3.723,3,3.723c1.291,0,2.581-0.332,3.679-0.859       c0.16,0.416,0.224,1.082,0.224,1.527c0,0.861-2.032,1.529-4.451,1.529c-2.999,0-5.161-1.086-5.161-6.502       c0-6.947,2.871-7.947,5.709-7.947C99.339,57.696,100.725,59.169,100.725,62.169 M93.662,64.392       c1.226,0.029,3.226-0.027,4.354-0.305c0.129-0.5,0.162-1.139,0.162-1.668c-0.033-2-0.452-2.75-1.839-2.75       C95.016,59.669,93.855,60.642,93.662,64.392"
}), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#SVGID_34_)",
  fill: "#58595B",
  d: "M102.693,58.946c1.258-0.75,2.806-1.25,4.387-1.25       c1.644,0,2.257,0.416,2.257,1.166c0,0.307-0.064,0.861-0.29,1.334c-0.484-0.221-1-0.332-1.547-0.332       c-0.711,0-1.517,0.193-2.13,0.639l-0.031,10.92c0,0.443-0.034,0.443-2.646,0.443V58.946z"
}), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#SVGID_34_)",
  fill: "#58595B",
  d: "M110.725,58.446c0.548-0.307,2.451-0.75,4.903-0.75c2.774,0,4,0.889,4,3.391       v1.471c0,3.197-0.033,6.531-0.194,8.643c-0.871,0.445-2.387,0.945-4.484,0.945c-2.355,0.027-4.613-0.418-4.613-4.225       c0-3.861,2.129-4.557,4.291-4.557c0.709,0,1.71,0.084,2.355,0.361V61.53c0-1.305-0.71-1.639-2.001-1.639       c-1.613,0-3.322,0.277-4.257,0.611c-0.289-0.445-0.355-0.945-0.355-1.277C110.37,58.919,110.467,58.612,110.725,58.446        M115.466,65.06c-1.29,0-2.387,0.389-2.387,2.807c0,2.027,0.839,2.389,2.097,2.389c0.71,0,1.419-0.223,1.71-0.473       c0.097-0.916,0.097-2.973,0.097-4.473C116.563,65.142,115.917,65.06,115.466,65.06"
}), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#SVGID_34_)",
  fill: "#58595B",
  d: "M68.94,76.593c-0.493,0.016-0.939,0.012-1.294-0.025       c-0.148,0.496-0.051,0.994,0.057,1.314c0.099,0.295,0.294,0.566,0.606,0.668c0.143,0.037,0.36,0.066,0.631,0.08       c0.134,0.008-0.119-0.002,0.043,0c2.504-0.035,4.09-0.697,5.589-1.977c0.486-0.414,0.886-0.881,1.22-1.391       c0.726-1.105,1.101-2.426,1.101-3.953V58.38l-0.161-0.043c-1.329-0.363-2.779-0.549-4.307-0.549c-2.073,0-3.631,0.58-4.63,1.723       c-0.947,1.086-1.44,2.803-1.473,5.098c-0.001,0.08-0.006,0.156-0.006,0.238c0,0.957,0.083,1.811,0.238,2.572       c0.362,1.779,1.142,3.033,2.339,3.752c0.807,0.486,1.801,0.734,2.985,0.734c0.788,0,1.563-0.141,2.309-0.422v0.096       c0,1.404-0.455,2.549-1.34,3.412c-0.073,0.07-0.142,0.143-0.22,0.209c-0.822,0.703-1.455,1.158-2.78,1.307       C69.31,76.567,69.14,76.587,68.94,76.593 M71.878,69.853c-0.212,0-0.41-0.025-0.599-0.066c-1.283-0.288-2.024-1.541-2.21-3.752       c-0.032-0.367-0.047-0.764-0.047-1.188c0-0.265,0.009-0.518,0.022-0.762c0.076-1.363,0.362-2.391,0.859-3.055       c0.571-0.762,1.395-1.133,2.522-1.133c0.591,0,1.182,0.051,1.762,0.15v9.08c-0.077,0.061-0.157,0.115-0.237,0.17       C73.375,69.669,72.693,69.853,71.878,69.853"
}), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#SVGID_34_)",
  fill: "#4D4D4F",
  d: "M255.593,78.309V67.928c0-2.752-1.267-4.635-3.708-4.635       s-3.707,1.883-3.707,4.635v7.891c0,2.463-1.978,2.934-3.835,2.621V67.928c0-4.584,2.107-8.068,7.542-8.068       c2.52,0,4.317,0.754,5.527,2.014c1.209-1.178,3.067-2.014,5.725-2.014c5.435,0,7.542,3.484,7.542,8.068v10.512       c-1.858,0.313-3.835-0.158-3.835-2.621v-7.891c0-2.752-1.265-4.635-3.707-4.635c-2.441,0-3.707,1.883-3.707,4.635v10.381H255.593z       "
}), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#SVGID_34_)",
  fill: "#4D4D4F",
  d: "M284.811,73.008c-0.094,2.057-7.123,4.135-7.123-0.035       c0-3.834,7.123-3.326,7.123-3.326V73.008z M288.251,63.895c-0.222-0.86-1.009-3.89-6.546-3.89c-3.606,0-5.605,1.212-6.02,1.511       c-0.49,0.352-0.737,0.752-0.737,1.191c0,0.266,0.036,0.607,0.222,1.002c0.386,0.816,0.975,1.263,0.975,1.263       s2.492-1.571,5.194-1.571c1.372,0,2.292,0.254,2.745,0.74c0.748,0.799,0.689,2.41,0.689,2.41c-0.126-0.006-0.26-0.008-0.401-0.008       c0,0-10.52-0.584-10.52,6.611c0,1.078,0.185,1.982,0.551,2.689c0.365,0.703,1.477,2.789,5.294,2.789       c3.493,0,4.804-1.41,5.336-1.859c0.434,1.266,1.357,2.08,3.54,1.666V66.762C288.573,65.692,288.464,64.727,288.251,63.895"
}), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#SVGID_34_)",
  fill: "#4D4D4F",
  d: "M236.553,73.008c-0.094,2.057-7.122,4.135-7.122-0.035       c0-3.834,7.122-3.326,7.122-3.326V73.008z M239.994,63.895c-0.222-0.86-1.009-3.89-6.546-3.89c-3.606,0-5.605,1.212-6.021,1.511       c-0.489,0.352-0.737,0.752-0.737,1.191c0,0.266,0.038,0.607,0.224,1.002c0.386,0.816,0.973,1.263,0.973,1.263       s2.493-1.571,5.197-1.571c1.371,0,2.288,0.254,2.743,0.74c0.747,0.799,0.69,2.41,0.69,2.41c-0.127-0.006-0.262-0.01-0.402-0.01       c0,0-10.52-0.582-10.52,6.613c0,1.078,0.186,1.982,0.551,2.689c0.366,0.703,1.477,2.789,5.293,2.789       c3.493,0,4.805-1.41,5.336-1.859c0.435,1.266,1.358,2.08,3.541,1.666V66.762C240.316,65.692,240.207,64.727,239.994,63.895"
}), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#SVGID_34_)",
  fill: "#4D4D4F",
  d: "M218.249,57.553c0-1.963,1.66-2.777,3.106-2.777       c2.399,0,3.758,2.156,3.758,2.156c0.206-0.307,2.324-2.367,1.134-3.738c-1.134-1.303-3.665-1.813-4.892-1.813       c-3.75,0-6.941,2.296-6.941,6.173v20.732h3.835V63.768h4.064c2.159,0,2.572-1.729,2.297-3.361h-6.361v-0.004V57.553z"
}), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#SVGID_34_)",
  fill: "#FFFFFF",
  d: "M272.792,0.387c0,0-7.844,0.004-18.103,0.004       c-3.732,0-7.634,3.115-8.862,7.625c-3.896,1.254-7.379,4.713-7.379,14.254v18.917c-0.001,0.002,0.045,0.002,0.124,0.002       l-0.125-0.002c0.393,0,0.738,0.008,1.067,0.006c1.07,0.004,2.563,0.004,2.563,0.004c0.698,0,1.378-0.066,2.033-0.195       c2.369-0.463,4.073-1.601,5.271-3.345c1.049-1.526,1.312-2.838,1.575-4.526c0.052-0.488,0.08-0.996,0.077-1.527v-0.113       c0.008-0.368,0.009-0.756,0.009-1.167l-0.009-4.279v-0.472c0.014-2.098,1.405-3.147,2.704-3.155c0.828,0,2.508,0.008,4.385,0.008       c4.927,0,5.046-4.478,5.046-4.572l0.002-0.051l-0.005-2.318h-12.168c0.148-3.723,2.495-5.303,5.453-5.303       c2.44,0,5.116,0.006,7.222,0.006c4.158-0.014,8.652-1.846,9.137-7.879C272.817,2.199,272.798,0.498,272.792,0.387"
}), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#SVGID_34_)",
  fill: "#009EDF",
  d: "M251.032,25.596c0-2.117,1.4-3.174,2.705-3.184       c0.828,0,2.507,0.01,4.385,0.01c5.026,0,5.048-4.638,5.048-4.58l-0.005-2.357h-12.169c0.128-3.717,2.513-5.309,5.454-5.309       c2.44,0,5.116,0.006,7.221,0.006c4.158-0.014,8.653-1.846,9.138-7.879c0.009-0.109-0.009-1.811-0.017-1.92       c0,0-7.844,0.002-18.104,0.002c-4.504,0-9.258,4.535-9.258,10.586c0,1.797,0.013,10.896,0.013,12.691       c0,5.362,0.043,8.186-0.629,11.418c-0.503,2.411-3.307,6.107-6.367,6.107c1.243,0,2.02,0.014,3.237,0.008       c3.03,0.082,5.964-0.963,7.697-3.538c1.304-1.848,1.786-4.334,1.65-7.317L251.032,25.596z"
}));

var _ref29 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#SVGID_2_)"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_35_",
  d: "M238.448,41.188v0.003V41.188z M238.448,41.188L238.448,41.188z M238.448,22.266v-0.045V22.266z          M238.448,22.2v-0.027V22.2z M238.448,22.147v-0.019V22.147z M238.448,22.014v-0.003V22.014z M238.448,21.969v-0.006V21.969z          M239.827,13.719v-0.002V13.719z M239.866,13.625c0-0.001,0.001-0.005,0.004-0.008C239.867,13.62,239.866,13.624,239.866,13.625          M239.877,13.6c0.001-0.003,0.003-0.008,0.005-0.011C239.88,13.592,239.878,13.597,239.877,13.6 M239.888,13.575         c0.002-0.006,0.005-0.014,0.008-0.022C239.893,13.561,239.89,13.569,239.888,13.575 M239.899,13.545         c0.004-0.008,0.008-0.017,0.013-0.027C239.907,13.528,239.903,13.537,239.899,13.545 M239.913,13.514         c0.003-0.009,0.007-0.017,0.011-0.027C239.92,13.497,239.916,13.505,239.913,13.514 M239.926,13.483         c0.033-0.074,0.065-0.148,0.099-0.221C239.991,13.335,239.959,13.409,239.926,13.483 M240.025,13.262         c0.021-0.044,0.041-0.089,0.063-0.134C240.066,13.173,240.046,13.218,240.025,13.262 M240.088,13.128         c0.365-0.776,0.781-1.446,1.236-2.03C240.869,11.682,240.453,12.352,240.088,13.128 M241.324,11.098         c0.02-0.025,0.04-0.05,0.059-0.075C241.364,11.048,241.344,11.073,241.324,11.098 M252.672,11.434         c0.804-0.703,1.841-1.095,2.998-1.215C254.507,10.339,253.472,10.729,252.672,11.434 M260.186,10.184h0.174H260.186z          M260.47,10.186c-0.037,0-0.073-0.002-0.11-0.002C260.397,10.184,260.433,10.186,260.47,10.186 M263.671,10.188         c-0.972,0-2.066,0-3.201-0.002c1.135,0.002,2.229,0.004,3.201,0.004c2.209-0.008,4.514-0.524,6.261-1.922         C268.185,9.661,265.88,10.182,263.671,10.188 M241.383,11.023c1.259-1.573,2.812-2.482,4.438-3.007         C244.196,8.539,242.642,9.45,241.383,11.023"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_36_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_35_",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#SVGID_36_)"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "SVGID_37_",
  x: 238.035,
  y: 7.656,
  width: 32.354,
  height: 34.012
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_38_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_37_",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1 0 0 1 -7.328636e-006 -1.797152e-006)",
  clipPath: "url(#SVGID_38_)"
}, /*#__PURE__*/React.createElement("image", {
  overflow: "visible",
  width: 117,
  height: 123,
  xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEBBAEEAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAALfAAAD2gAABQb/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAH4AdwMBIgACEQEDEQH/ xACTAAACAwEBAAAAAAAAAAAAAAABAgADBAUGAQADAQEAAAAAAAAAAAAAAAAAAQQDBRAAAgECBQQD AQAAAAAAAAAAAAECAwUQIBMzQxESBBYxFAYjEQAAAwgCAgIDAAAAAAAAAAAAAgMwAZGxknMENDLT ESFB0mESMxIAAQQDAQEAAAAAAAAAAAAAAEGBkQIwATIRMf/aAAwDAQACEQMRAAAAunFPV5faPEYO 0eKUu0eMRdk8dhdd+NYLtXcfTnt3Zlk9XiiD0IIysIkETEETMrCNldiWjTm057dOSS2eKIN8UZWE SCJiCJmVhGyuxLRpzac9unJJbPFEG+KMrCJBExBEzKwjZXYlo05tOe3TkktniiDfFGVhEgiYgiZl YRsrsS0ac2nPbpySWzxRBvijKwiQRMQRMysI2V2JaNObTnt05JLZ4og3xRlYRIImIImZWEbK7EtG nNpz26ckls8UbjdHQ1xFSbmFSbiKprSKqx3SbTXpz23R5NZ//9oACAECAAEFANGmaNM0aZo0zRpm jTJUoHbHWyskc+Vkjnyskc+Vkjnyskc+Vkjn7kdyO5HcjqhtEmdf7f/aAAgBAwABBQDWqGtUNaoa 1U16pr1esatQ7paOVfMDgyr5gcGVfMDgyr5gcGVfMDgyr5gcHRnRnaztZ2sUX1imdP4f/9oACAEB AAEFAPbbwe23g9svB7Xdz2u7ntV2Pabse0XYX6i6ns91F+muhH9Jc2R/QXFkL35zPEuHk1YYoQhC EIRAgUy37eKEIQhCEQIFMt+3ihCEIQhECBTLft4oQhCEIRAgUy37eKEIQhCEQIFMt+3ihCEIQhEC BTLft4oQhCEIRAgUy37eKEIQhCEQIFMt+3ihCEIQhECBTLft4oQhCEIRAgUy37eKEIQhCEQIFMt+ 3ihCEIQhECBTLft4oQhCEIRAgUy37eKEIQhCEQIFMt+39aifWon1qIvGon1qIvHoi8eifXoi8ekL x6QvHpEaFIhRplOlTPBhFU//2gAIAQICBj8A4rBxWDisHFYOKwcVg5rB55rzz5gbA2BsDYGwMLGx Y2LGxY2LAsCwMf/aAAgBAwIGPwDu0ndpO7Sd2k7tJ3aTq0nvu/ffuB8D4HwPgfA4kiSJOhJ0JOhJ 0JI5/9oACAEBAQY/AOSdDhyTocOSdDhyTocORKHDkShw5EocORKHDkShw5EpcORKRyJSPZiUj28t IXMd7vKaZjl8O+XN8qyeTfKsnk3yrJ5N8qyeTfKsnk3yrJ5N8qyeTfKsnk3yrJ5N8qyeTfKsnk3y rJ5N8qyeTfKsnkNtKCvUNtKCvUNtKCvUNtKCvUNpKCvUNpKCvUNpKCvUNpKCvWNpKCvWNlKCvWNl KCnWNlOCnWNhOCn0H9iQP9Bk+FCm8omc/wAft6/Pso//2Q==",
  transform: "matrix(0.2765 0 0 -0.2765 238.0347 41.668)"
}))));

var _ref30 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#SVGID_2_)"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_39_",
  d: "M252.191,11.926c0.042-0.048,0.083-0.097,0.127-0.144C252.274,11.829,252.233,11.877,252.191,11.926          M252.318,11.782c0.007-0.008,0.014-0.016,0.021-0.023C252.332,11.766,252.325,11.774,252.318,11.782 M252.339,11.759         c0.001-0.002,0.002-0.003,0.004-0.005C252.341,11.756,252.34,11.757,252.339,11.759 M252.343,11.754         c0.085-0.091,0.173-0.18,0.265-0.264C252.516,11.573,252.427,11.663,252.343,11.754 M252.608,11.49         c0.022-0.019,0.042-0.038,0.064-0.056c0.032-0.028,0.063-0.056,0.095-0.083C252.714,11.396,252.66,11.443,252.608,11.49          M252.767,11.351c0.02-0.016,0.041-0.033,0.061-0.049C252.807,11.318,252.787,11.334,252.767,11.351 M252.828,11.302         c0.091-0.073,0.182-0.139,0.276-0.204C253.01,11.163,252.918,11.229,252.828,11.302 M253.104,11.098h0.003H253.104z          M253.107,11.098c0.011-0.01,0.024-0.018,0.038-0.027C253.131,11.08,253.118,11.088,253.107,11.098 M253.145,11.071         c0.001,0,0.002,0,0.003-0.002C253.147,11.071,253.146,11.071,253.145,11.071 M253.148,11.069c0.013-0.009,0.025-0.018,0.04-0.026         C253.173,11.051,253.161,11.06,253.148,11.069 M253.188,11.043L253.188,11.043L253.188,11.043z M253.189,11.043         c0.013-0.01,0.025-0.017,0.038-0.025C253.214,11.026,253.202,11.033,253.189,11.043 M253.227,11.018         c0.002-0.002,0.004-0.003,0.006-0.003C253.231,11.015,253.229,11.016,253.227,11.018 M253.233,11.015         c0.012-0.009,0.024-0.017,0.037-0.024C253.257,10.998,253.245,11.006,253.233,11.015 M253.27,10.991         c0.006-0.004,0.012-0.008,0.019-0.012C253.282,10.983,253.276,10.987,253.27,10.991 M253.289,10.979         c0.005-0.002,0.01-0.006,0.017-0.009C253.299,10.973,253.294,10.977,253.289,10.979 M253.306,10.97         c0.008-0.005,0.016-0.01,0.024-0.017C253.322,10.96,253.314,10.965,253.306,10.97 M253.33,10.953         c0.002-0.001,0.005-0.001,0.006-0.001C253.335,10.952,253.332,10.952,253.33,10.953 M239.926,13.483         c0,0.002-0.001,0.002-0.002,0.004c-0.004,0.01-0.008,0.018-0.011,0.027c0,0.003,0,0.003-0.001,0.004         c-0.005,0.01-0.009,0.019-0.013,0.027c-0.002,0.002-0.002,0.007-0.003,0.008c-0.003,0.008-0.006,0.016-0.008,0.022         c-0.003,0.004-0.005,0.01-0.006,0.014c-0.002,0.003-0.004,0.008-0.005,0.011c-0.003,0.006-0.005,0.012-0.007,0.017         c-0.003,0.003-0.004,0.007-0.004,0.008c-0.01,0.024-0.019,0.045-0.029,0.067v0.002c-0.003,0.008-0.006,0.018-0.01,0.023v0.002         c-0.836,2.036-1.351,4.715-1.379,8.244v0.006v0.042v0.003c0,0.037,0,0.074,0,0.114v0.019v0.026V22.2v0.021v0.045v0.004v18.917         c0.154-0.291,3.592-1.862,3.592-10.41c0-2.87-0.021-4.848-0.021-8.09c0-3.558,1.399-5.389,3.416-6.31         c-0.003-2.389-0.005-4.612-0.005-5.407c0-1.035,0.138-2.023,0.391-2.955C243.488,8.77,241.302,10.313,239.926,13.483          M263.671,10.184c-2.106,0-4.782-0.007-7.222-0.007c-1.159,0-2.231,0.245-3.113,0.775c0.679-0.406,1.472-0.645,2.334-0.733         c0.255-0.025,0.515-0.037,0.779-0.037c1.222,0,2.501,0.002,3.737,0.002c1.237,0.004,2.432,0.004,3.485,0.004         c2.209-0.006,4.514-0.527,6.261-1.92c0.378-0.301,0.729-0.645,1.047-1.031C269.184,9.407,266.358,10.172,263.671,10.184"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_40_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_39_",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#SVGID_40_)"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "SVGID_41_",
  x: 238.035,
  y: 6.826,
  width: 33.459,
  height: 34.842
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_42_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_41_",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1 0 0 1 -6.653772e-006 -1.797152e-006)",
  clipPath: "url(#SVGID_42_)"
}, /*#__PURE__*/React.createElement("image", {
  overflow: "visible",
  width: 121,
  height: 126,
  xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEBBAEEAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAALyAAADvQAABIj/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAIIAewMBIgACEQEDEQH/ xACRAAACAwEBAAAAAAAAAAAAAAABAgAEBQMHAQEBAQEBAAAAAAAAAAAAAAABAAMEBRAAAgIBAwQC AwAAAAAAAAAAAAECAyATBRYxMjMGMBIQEQQRAAEDBAECBwEAAAAAAAAAAABAkoQBAjJDAyFB8DGB kUKCEzMSAAEFAQEBAQAAAAAAAAAAAAIAMIGRsTIBESH/2gAMAwEAAhEDEQAAAO0xT6vl7RxGraOK Q2jjGNk47RrvjdI2u2PZz21tPA28d/OCD3ccZWgkGGIMMytB6c+gWLNaznta28Tbw6fOCD2csZWg kGGIMMytB6c+gWLNaznta28Tbw6fOCD2csZWgkGGIMMytB6c+gWLNaznta28Tbw6fOCD2csZWgkG GIMMytB6c+gWLNaznta28Tbw6fOCD2csZWgkGGIMMytB6c+gWLNaznta28Tbw6fOCD2csZWgkGGI MMytB6c+gWLNaznta28Tbw6fOCD2csZWgkGGIMMytB6c+gWLNaznta28Tbw6WknN1SSUZJUklQyV JJBMgs8g/wD/2gAIAQIAAQUA0azRrNGs0azRrNGslVAlCP3xZIl34skS78WSJd+LJEu/FkiXfiyR LvxZIl3/AAf/2gAIAQMAAQUA1rDWsNaw1rTXtNe39xtsIzl9MV1gR8eK6wI+PFdYEfHiusCPjxXW BHx4rrAj48V1gR8fwf/aAAgBAQABBQDlu8HLd4OWbwcr3c5Xu5yrdjlO7HKN2F7RupyfdRezboR9 k3NkfYNxZDe/7mQ3X+tmvZghCEIQhECBWV4oQhCEIRAgVleKEIQhCEQIFZXihCEIQhECBWV4oQhC EIRAgVleKEIQhCEQIFZXihCEIQhECBWV4oQhCEIRAgVleKEIQhCEQIFZXihCEIQhECBWV4oQhCEI RAgVleKEIQhCEQIFZXihCEIQhECBWV4oQhCEIRAgVleKEIQhCEQIFZX86F+P/9oACAECAgY/AOBp cDS4GlwNLgaXA0uRpD588/frATjATjATjATjATjATjATjP8A/9oACAEDAgY/AOytdla7K12VrsrX ZWuitF799/PmsHGsHGsHGsHGsHGsHGsHGs//2gAIAQEBBj8Ay42UMuNlDLjZQy42UMrGUMrGUMrG UMrGUMrGUMrG0MrGmVjTrdY061tada2+x2/j+n2QRkEZBGQRkEZBGQRkEZBGQRkEZBGQRkEZBGNB oNBoNBoNBoNJpNJpNRrPgdvLx6H/2Q==",
  transform: "matrix(0.2765 0 0 -0.2765 238.0347 41.668)"
}))));

var _ref31 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#SVGID_2_)"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_43_",
  d: "M238.448,41.188L238.448,41.188z M266.761,7.301h-14.378h-0.14c-1.907,0-4.231,0.008-6.422,0.715         c-0.253,0.932-0.391,1.92-0.391,2.955c0,0.795,0.002,3.018,0.005,5.407c1.595-0.731,3.577-0.893,5.559-0.893         c0.053-1.537,0.492-2.711,1.197-3.559c0.999-1.201,2.534-1.749,4.258-1.749c2.44,0,5.116,0.007,7.222,0.007         c2.687-0.012,5.513-0.777,7.308-2.947c0.983-1.193,1.656-2.817,1.831-4.975C272.81,2.262,271.69,7.301,266.761,7.301"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_44_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_43_",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#SVGID_44_)"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "SVGID_45_",
  x: 238.035,
  y: 1.849,
  width: 35.119,
  height: 39.819
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_46_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_45_",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1 0 0 1 -1.543008e-005 -1.797152e-006)",
  clipPath: "url(#SVGID_46_)"
}, /*#__PURE__*/React.createElement("image", {
  overflow: "visible",
  width: 127,
  height: 144,
  xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEBBAEEAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAMJAAAD4AAABS7/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAJQAggMBIgACEQEDEQH/ xACbAAEBAQEBAQEAAAAAAAAAAAABAAIEBQYHAQADAQEBAAAAAAAAAAAAAAAAAQUCBgQQAAIABAYD AQEAAAAAAAAAAAABEDADBQIyEzUWJiAzBAYUEQAAAgoCAgMBAAAAAAAAAAAAAkABsTKSA0NzowQR EhBCITETFBIAAQIGAgEFAQAAAAAAAAAAAgAwAZGxMnJEEDFBIYESMzQD/9oADAMBAAIRAxEAAADV 4bWk+5eGh7j4aL23xEXt3ipn2nxVr2teLoz7PT8/25PvapV38lRtRZESiJREoiUXnWs6M67eLtyf e1Rui/JUbUWREoiURKIlF51rOjOu3i7cn3tUbovyVG1FkRKIlESiJRedazozrt4u3J97VG6L8lRt RZESiJREoiUXnWs6M67eLtyfe1Rui/JUbUWREoiURKIlF51rOjOu3i7cn3tUbovyVG1FkRKIlESi JRedazozrt4u3J97VG6L8lRtRZESiJREoiUXnWs6M67eLtyfe1Rui/JUbUWREoiURKIlF51rOjOu 3i7cn3tUbovjGvf4KoGoTUDUJaEtCeikfRVeGn//2gAIAQIAAQUA0aRo0jRpGjSNGkaNI0aRjo0l hkY8kjHkkY8kjHkkY8kjHkkY8kjHkkYsp//aAAgBAwABBQDWqmtVNeqa9U16p/RWH9FYwfRWePyY yn7PJjKfs8mMp+zyYyn7PJjKfs8mMp+zyYyn7PJjKfskYcx//9oACAEBAAEFAOYXo5heTl95OX3k 5feTl15OXXg5beDlt4OWXc5Xdzld3F+quwv1F2F+nup8H6C4/R9slCghCEWnc5KFBCEItO5yUKCE IRadzkoUEIQi07nJQoIQhFp3OShQQhCLTuclCghCEWnc5KFBCEItO5yUKCEIRadzkoUEIQi07nJQ oIQhFp3OShQQhCLTuclCghCEWnc5KFBCEItO5yUKCEIRadzkoUEIQi07nJQoIQhFp3M6OdIOkHST pJ0o6UdLOlnTDpp046edQFxE+LjX9R//2gAIAQICBj8AsGSsGSsGSsGSsGSsGSsGSKPwG2PhksYs ljFksYsljFksYsljFksYsljHjaW0tpbS2ltLaUf09eeuP//aAAgBAwIGPwC8pq8pq8pq8pq8pr7D mvsOaGEf6H6lDyyGY1ZDMashmNWQzGrIZjVkMxqyGY1ZDMa8aq1VqrUWotNaSH8XcOu/bj//2gAI AQEBBj8AelwKD0uBQelwKD0uBQelwKD0uBQelwKD0uBQelwKD0uBQelwKDxIFB4kCg8SBQeJAoSJ MwxOkw5Sm4Lwvha0HVulag6t0rUHVulag6t0rUHVulag6t0rUHVulag6t0rUHVulag6t0rUHVula g6t0rUHVulag6t0rUHVulag6t0rUHVulb4qZRUyiplFTKKmUVMoqZRUyiplFTKKmUe+Qe+Qe+Qe+ QSf5u/791fnz347c/H34/9k=",
  transform: "matrix(0.2765 0 0 -0.2765 238.0347 41.668)"
}))));

var _ref32 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#SVGID_2_)"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_47_",
  d: "M263.17,17.8v-0.059V17.8z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_48_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_47_",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#SVGID_48_)"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "SVGID_49_",
  x: 262.646,
  y: 17.335,
  width: 0.83,
  height: 0.83
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_50_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_49_",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1 0 0 1 3.241847e-006 8.916463e-007)",
  clipPath: "url(#SVGID_50_)"
}, /*#__PURE__*/React.createElement("image", {
  overflow: "visible",
  width: 3,
  height: 3,
  xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEBBAEEAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAF0AAABgAAAAan/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAAQABwMBIgACEQEDEQH/ xABoAAEBAAAAAAAAAAAAAAAAAAAABgEBAQAAAAAAAAAAAAAAAAAAAwQQAQEBAAAAAAAAAAAAAAAA AEEDNREAAgIDAAAAAAAAAAAAAAAAMTMAAWECAxIAAwAAAAAAAAAAAAAAAAAAAMGD/9oADAMBAAIR AxEAAACsDz//2gAIAQIAAQUAf//aAAgBAwABBQA//9oACAEBAAEFAJ7v/9oACAECAgY/AIo//9oA CAEDAgY/ALs//9oACAEBAQY/AOrF0VDUZn//2Q==",
  transform: "matrix(0.2765 0 0 -0.2765 262.646 18.1646)"
}))));

var _ref33 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#SVGID_2_)"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_51_",
  d: "M258.122,22.422h0.016H258.122z M258.138,22.422h0.023H258.138z M261.684,21.202         c-0.741,0.689-1.854,1.211-3.523,1.22c1.683-0.009,2.801-0.539,3.543-1.237C261.697,21.19,261.69,21.196,261.684,21.202          M261.704,21.185c0.002-0.003,0.006-0.005,0.008-0.009C261.708,21.18,261.706,21.182,261.704,21.185 M261.712,21.176         c0.002-0.001,0.005-0.003,0.008-0.006C261.717,21.173,261.714,21.175,261.712,21.176"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_52_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_51_",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#SVGID_52_)"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "SVGID_53_",
  x: 257.668,
  y: 20.653,
  width: 4.424,
  height: 2.212
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_54_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_53_",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1 0 0 1 -7.046550e-006 -1.366638e-006)",
  clipPath: "url(#SVGID_54_)"
}, /*#__PURE__*/React.createElement("image", {
  overflow: "visible",
  width: 16,
  height: 8,
  xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEBBAEEAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGmAAABxgAAAjb/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAA4AFgMBIgACEQEDEQH/ xACLAAACAwAAAAAAAAAAAAAAAAAABAIFBgEAAwAAAAAAAAAAAAAAAAAAAgMEEAABBAIDAQAAAAAA AAAAAAAEAAIDBQESERUGFhEAAQIEAwYHAAAAAAAAAAAAAgEDABESBCFBUTFhcSIykqLSEzPTNAUS AAEDBQEAAAAAAAAAAAAAAAABESExEiKCQwL/2gAMAwEAAhEDEQAAANEk0jVHbkQGf//aAAgBAgAB BQBjh9eYV//aAAgBAwABBQCRpWXazr//2gAIAQEAAQUAt78kAz6w1MuJ3UtyPTSHYE82mQ1fRf/a AAgBAgIGPwBLkyaYKdH0P//aAAgBAwIGPwD1auLxKFeTbn//2gAIAQEBBj8AW3bbAhQUKZTnjwWP Za8Xmhz9FQD1QKSBjT1COs84Ury6Nl6kZgIqqSy2Asfed7C+OHGxuDWyUuZ6lakWscqdd0f/2Q==",
  transform: "matrix(0.2765 0 0 -0.2765 257.6685 22.8657)"
}))));

var _ref34 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#SVGID_2_)"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_55_",
  d: "M258.108,22.418c-0.938,0-1.826-0.001-2.583-0.005c0.76,0.004,1.653,0.009,2.597,0.009         c1.691,0,2.815-0.525,3.562-1.22C260.935,21.895,259.806,22.418,258.108,22.418"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_56_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_55_",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#SVGID_56_)"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "SVGID_57_",
  x: 255.18,
  y: 20.653,
  width: 6.913,
  height: 2.212
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_58_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_57_",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1 0 0 1 -1.790513e-005 -1.366638e-006)",
  clipPath: "url(#SVGID_58_)"
}, /*#__PURE__*/React.createElement("image", {
  overflow: "visible",
  width: 25,
  height: 8,
  xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEBBAEEAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGmAAABygAAAkT/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAA4AHQMBIgACEQEDEQH/ xACJAAEBAQEAAAAAAAAAAAAAAAADBQEGAQEBAAAAAAAAAAAAAAAAAAACBBAAAQMEAwEAAAAAAAAA AAAABAABAhEDBhYTFBUFEQAABgACCQUAAAAAAAAAAAAAARECEgMTMyExUVKSotLTNWEyBBQVEgAB AwUBAAAAAAAAAAAAAAABAAISESFBoUIy/9oADAMBAAIRAxEAAACmeHbCtznrwf8A/9oACAECAAEF AGmLS5Id1//aAAgBAwABBQB4GVtxJZf/2gAIAQEAAQUAJy82yTuZ63I5ete8EoPGJFdLFV0sVXF8 3Xv/2gAIAQICBj8AFW6KbAdiVucr/9oACAEDAgY/ADR2wnzPBjcesL//2gAIAQEBBj8AtpbTUba3 uYRnJUaZlvDIq5uoZFXN1D9SDcWMoaY++G1Rcdvz7W2HY43tJjkJympZe0eQt4HdoeQt4HdsYWO7 6Ec9Dkk92K6/Qf/Z",
  transform: "matrix(0.2765 0 0 -0.2765 255.1797 22.8657)"
}))));

var _ref35 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#SVGID_2_)"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_59_",
  d: "M253.388,22.44c-0.045,0.008-0.092,0.017-0.14,0.027c0.124-0.025,0.248-0.042,0.372-0.05         C253.542,22.42,253.465,22.43,253.388,22.44"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_60_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_59_",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#SVGID_60_)"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "SVGID_61_",
  x: 252.967,
  y: 22.036,
  width: 1.106,
  height: 0.83
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_62_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_61_",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1 0 0 1 -1.778956e-005 -1.721227e-006)",
  clipPath: "url(#SVGID_62_)"
}, /*#__PURE__*/React.createElement("image", {
  overflow: "visible",
  width: 4,
  height: 3,
  xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEBBAEEAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGBAAABkAAAAcX/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAAcACwMBIgACEQEDEQH/ xABzAAEBAQAAAAAAAAAAAAAAAAAABAYBAQAAAAAAAAAAAAAAAAAAAAIQAAEFAQAAAAAAAAAAAAAA AAEAERIDBAURAAEDBQAAAAAAAAAAAAAAAAIBIQMQQXIzBBIAAgIDAQAAAAAAAAAAAAAAETEAAYEC EjL/2gAMAwEAAhEDEQAAANjeMf/aAAgBAgABBQAtH//aAAgBAwABBQAPL//aAAgBAQABBQDdo6dV 6//aAAgBAgIGPwDXyrIeZ//aAAgBAwIGPwDY9OgVif/aAAgBAQEGPwCIePnGaItpqri+SWp//9k=",
  transform: "matrix(0.2765 0 0 -0.2765 252.9673 22.8657)"
}))));

var _ref36 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#SVGID_2_)"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_63_",
  d: "M253.723,22.409c-0.11,0.004-0.222,0.013-0.335,0.031c0.077-0.01,0.154-0.02,0.232-0.023         c0.039-0.004,0.077-0.004,0.116-0.004c0.165-0.003,0.364-0.004,0.589-0.004H253.723z M254.325,22.409h0.058H254.325z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_64_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_63_",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#SVGID_64_)"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "SVGID_65_",
  x: 252.967,
  y: 22.036,
  width: 1.936,
  height: 0.83
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_66_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_65_",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1 0 0 1 -1.778956e-005 -1.721227e-006)",
  clipPath: "url(#SVGID_66_)"
}, /*#__PURE__*/React.createElement("image", {
  overflow: "visible",
  width: 7,
  height: 3,
  xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEBBAEEAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGHAAABmQAAAdb/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAAcACwMBIgACEQEDEQH/ xAB3AAEBAQAAAAAAAAAAAAAAAAAABAYBAQAAAAAAAAAAAAAAAAAAAAMQAAEEAwAAAAAAAAAAAAAA ABIBAxMFBBQGEQACAQMEAwAAAAAAAAAAAAABEQIAEjIhMUIEUhQFEgABBQEAAAAAAAAAAAAAAAAS AAERgTLR/9oADAMBAAIRAxEAAADXSij/AP/aAAgBAgABBQBRj//aAAgBAwABBQBCl//aAAgBAQAB BQC0yrdhzf6QP//aAAgBAgIGPwBsTZL/2gAIAQMCBj8AfY0PV//aAAgBAQEGPwCA+f1Y9iBBMzIp F7ZRp+hC6xp8r0s/HWv/2Q==",
  transform: "matrix(0.2765 0 0 -0.2765 252.9673 22.8657)"
}))));

var _ref37 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#SVGID_2_)"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_67_",
  d: "M251.493,23.742c0.004-0.005,0.007-0.011,0.011-0.017C251.5,23.731,251.497,23.736,251.493,23.742          M251.504,23.725c0.003-0.004,0.005-0.009,0.008-0.013C251.509,23.716,251.507,23.721,251.504,23.725 M251.512,23.712         c0.003-0.005,0.006-0.01,0.009-0.015C251.517,23.702,251.515,23.707,251.512,23.712 M251.53,23.682         c-0.004,0.005-0.006,0.01-0.009,0.015c0.006-0.01,0.013-0.021,0.02-0.031C251.537,23.671,251.534,23.677,251.53,23.682          M251.541,23.666c0.017-0.025,0.032-0.05,0.049-0.075C251.573,23.615,251.557,23.641,251.541,23.666 M251.59,23.591         c0.006-0.007,0.011-0.015,0.017-0.022C251.601,23.576,251.596,23.584,251.59,23.591"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_68_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_67_",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#SVGID_68_)"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "SVGID_69_",
  x: 251.032,
  y: 23.143,
  width: 1.106,
  height: 1.106
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_70_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_69_",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1 0 0 1 -7.873199e-006 -1.022014e-006)",
  clipPath: "url(#SVGID_70_)"
}, /*#__PURE__*/React.createElement("image", {
  overflow: "visible",
  width: 4,
  height: 4,
  xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEBBAEEAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAF9AAABjAAAAcT/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAAcABwMBIgACEQEDEQH/ xABuAAEBAAAAAAAAAAAAAAAAAAAABgEBAAAAAAAAAAAAAAAAAAAAAxAAAwEBAAAAAAAAAAAAAAAA IhMFAwQRAAEEAgMAAAAAAAAAAAAAAAIBEQMEEhMAITESAAIDAAAAAAAAAAAAAAAAAAAxEkKi/9oA DAMBAAIRAxEAAACnDD//2gAIAQIAAQUAN3//2gAIAQMAAQUABP8A/9oACAEBAAEFAJ86vhzf/9oA CAECAgY/AKSyj//aAAgBAwIGPwC8dM//2gAIAQEBBj8AuR2bW2WYMa57DLAmNHckdO1Tzn//2Q==",
  transform: "matrix(0.2765 0 0 -0.2765 251.0317 24.2485)"
}))));

var _ref38 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#SVGID_2_)"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_71_",
  d: "M251.083,24.911c0.004-0.027,0.009-0.054,0.013-0.081C251.092,24.857,251.087,24.884,251.083,24.911          M251.096,24.83c0.005-0.026,0.009-0.05,0.014-0.075C251.105,24.779,251.101,24.804,251.096,24.83 M251.11,24.755         c0.027-0.136,0.062-0.265,0.101-0.388C251.171,24.49,251.137,24.62,251.11,24.755 M251.211,24.367         c0.001-0.003,0.002-0.005,0.003-0.009C251.213,24.362,251.212,24.364,251.211,24.367 M251.214,24.358         c0.002-0.005,0.004-0.012,0.006-0.017C251.218,24.346,251.216,24.353,251.214,24.358 M251.22,24.341         c0.022-0.065,0.046-0.129,0.071-0.191C251.265,24.212,251.242,24.275,251.22,24.341 M251.291,24.15         c0.01-0.025,0.02-0.049,0.03-0.073C251.311,24.101,251.301,24.125,251.291,24.15 M251.321,24.077         c0.006-0.013,0.012-0.027,0.018-0.04C251.333,24.05,251.327,24.064,251.321,24.077 M251.339,24.037         c0.001,0,0.001-0.001,0.001-0.002C251.34,24.036,251.34,24.037,251.339,24.037 M251.359,23.994L251.359,23.994 M251.34,24.035         c0.006-0.014,0.013-0.027,0.019-0.041C251.353,24.008,251.346,24.021,251.34,24.035 M251.359,23.994L251.359,23.994          M251.359,23.993C251.359,23.994,251.359,23.994,251.359,23.993C251.359,23.994,251.359,23.994,251.359,23.993L251.359,23.993          M251.359,23.993L251.359,23.993 M251.359,23.993c0.006-0.012,0.013-0.026,0.02-0.039         C251.372,23.967,251.365,23.981,251.359,23.993 M251.379,23.954c0.003-0.006,0.005-0.012,0.009-0.018         C251.384,23.942,251.382,23.948,251.379,23.954 M251.388,23.936c0.003-0.006,0.006-0.013,0.009-0.019         C251.394,23.923,251.391,23.93,251.388,23.936 M251.397,23.917c0.004-0.008,0.009-0.016,0.012-0.024         C251.406,23.901,251.401,23.909,251.397,23.917 M251.409,23.893c0.003-0.005,0.005-0.009,0.008-0.013         C251.414,23.884,251.412,23.888,251.409,23.893 M251.417,23.88c0.003-0.008,0.008-0.016,0.012-0.024         C251.425,23.864,251.42,23.872,251.417,23.88 M251.429,23.856c0.003-0.005,0.005-0.009,0.007-0.014         C251.434,23.847,251.432,23.851,251.429,23.856 M251.436,23.842c0.004-0.007,0.008-0.015,0.013-0.022         C251.444,23.827,251.44,23.835,251.436,23.842 M251.449,23.82c0.003-0.006,0.005-0.01,0.008-0.015         C251.454,23.81,251.452,23.814,251.449,23.82 M251.457,23.805c0.004-0.007,0.007-0.013,0.012-0.02         C251.464,23.792,251.461,23.798,251.457,23.805 M251.469,23.785c0.003-0.007,0.006-0.013,0.01-0.018         C251.475,23.772,251.472,23.778,251.469,23.785 M251.479,23.767c0.003-0.006,0.006-0.011,0.009-0.017         C251.485,23.756,251.482,23.761,251.479,23.767 M251.488,23.75c0.002-0.002,0.003-0.005,0.005-0.007         C251.491,23.745,251.489,23.748,251.488,23.75 M251.493,23.743L251.493,23.743c0.001-0.002,0.003-0.005,0.004-0.007         C251.495,23.738,251.494,23.74,251.493,23.743 M251.497,23.736c0.011-0.019,0.022-0.036,0.033-0.054         C251.519,23.7,251.508,23.718,251.497,23.736"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_72_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_71_",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#SVGID_72_)"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "SVGID_73_",
  x: 250.755,
  y: 23.142,
  width: 1.106,
  height: 2.212
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_74_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_73_",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1 0 0 1 -1.767398e-005 -9.729783e-007)",
  clipPath: "url(#SVGID_74_)"
}, /*#__PURE__*/React.createElement("image", {
  overflow: "visible",
  width: 4,
  height: 8,
  xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEBBAEEAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGKAAABnAAAAeH/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAAsABwMBIgACEQEDEQH/ xAB7AAEBAQAAAAAAAAAAAAAAAAAABAUBAQAAAAAAAAAAAAAAAAAAAAQQAAICAwEAAAAAAAAAAAAA ABIEARMDBRUGEQABAwIHAQAAAAAAAAAAAAABEQIDABIhMXEiMwQUExIAAQMFAQAAAAAAAAAAAAAA EQABMVGRAhIyM//aAAwDAQACEQMRAAAA3FhRP//aAAgBAgABBQAoq//aAAgBAwABBQAZu//aAAgB AQABBQDZut4/TOj2f//aAAgBAgIGPwAaNxJxuv/aAAgBAwIGPwA7v6QMrUX/2gAIAQEBBj8A6nWj me2B/wA7owSGlXFVFQL4l2ct3pzPGmGlf//Z",
  transform: "matrix(0.2765 0 0 -0.2765 250.7549 25.354)"
}))));

var _ref39 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#SVGID_2_)"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_75_",
  d: "M243.47,41.108c0.019-0.003,0.039-0.007,0.058-0.008C243.509,41.102,243.489,41.105,243.47,41.108          M243.528,41.101c0.007-0.001,0.014-0.003,0.02-0.004C243.542,41.098,243.534,41.1,243.528,41.101 M243.548,41.097         c0.031-0.004,0.062-0.008,0.094-0.013c0.001,0,0.002-0.002,0.003-0.002C243.613,41.087,243.58,41.092,243.548,41.097          M243.645,41.082h0.002H243.645z M243.647,41.082h0.008H243.647z M243.655,41.082h0.005c0,0,0-0.001,0-0.002         C243.659,41.082,243.657,41.082,243.655,41.082 M243.66,41.08C243.661,41.08,243.661,41.08,243.66,41.08         C243.661,41.08,243.661,41.08,243.66,41.08 M243.661,41.08h0.003H243.661z M243.664,41.08h0.004H243.664z M243.668,41.08         L243.668,41.08c0.004-0.002,0.007-0.002,0.011-0.002C243.675,41.078,243.672,41.078,243.668,41.08 M243.694,41.076         c-0.004,0-0.009,0.002-0.015,0.002c0.007,0,0.014-0.002,0.02-0.002H243.694z M243.699,41.076         c0.026-0.006,0.054-0.008,0.082-0.014C243.753,41.068,243.725,41.07,243.699,41.076 M243.792,41.061         c-0.004,0-0.007,0-0.011,0.002c0.004-0.002,0.009-0.002,0.013-0.002H243.792z M243.794,41.061h0.004H243.794z M243.798,41.061         c0.004-0.001,0.006-0.002,0.01-0.003C243.804,41.058,243.801,41.059,243.798,41.061 M243.808,41.058c0.001,0,0.002,0,0.003,0         s0.001,0,0.001-0.001C243.811,41.058,243.809,41.058,243.808,41.058 M243.812,41.057c0.002,0,0.004,0,0.006,0         C243.816,41.057,243.814,41.057,243.812,41.057 M243.818,41.057c0.056-0.01,0.112-0.018,0.167-0.028         C243.93,41.039,243.874,41.047,243.818,41.057"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_76_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_75_",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#SVGID_76_)"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "SVGID_77_",
  x: 243.013,
  y: 40.563,
  width: 1.383,
  height: 0.829
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_78_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_77_",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1 0 0 1 -1.176404e-005 -7.127774e-007)",
  clipPath: "url(#SVGID_78_)"
}, /*#__PURE__*/React.createElement("image", {
  overflow: "visible",
  width: 5,
  height: 3,
  xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEBBAEEAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGAAAABjwAAAcL/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAAcABwMBIgACEQEDEQH/ xAByAAEBAAAAAAAAAAAAAAAAAAAABgEBAAAAAAAAAAAAAAAAAAAAAxAAAQUBAAAAAAAAAAAAAAAA IgASAxMFBBEAAAUFAQAAAAAAAAAAAAAAAQISAxMAESGBIgQSAAEFAAAAAAAAAAAAAAAAABEAYdES Qv/aAAwDAQACEQMRAAAAqAw//9oACAECAAEFADs//9oACAEDAAEFAAZ//9oACAEBAAEFAOTO2Yl/ /9oACAECAgY/AMENWF//2gAIAQMCBj8A2C9pX//aAAgBAQEGPwB6f3yraORrA8ODZJ9V/9k=",
  transform: "matrix(0.2765 0 0 -0.2765 243.0127 41.3926)"
}))));

var _ref40 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#SVGID_2_)"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_79_",
  d: "M242.076,41.195L242.076,41.195L242.076,41.195z M242.077,41.195h0.079H242.077z M242.156,41.195         c0.005,0,0.01,0,0.014-0.002C242.166,41.195,242.161,41.195,242.156,41.195 M242.17,41.193h0.069H242.17z M242.239,41.193h0.029         H242.239z M242.268,41.193c0.019,0,0.039,0,0.059-0.001C242.307,41.193,242.287,41.193,242.268,41.193 M242.327,41.192         c0.013,0,0.027,0,0.041-0.002C242.354,41.192,242.34,41.192,242.327,41.192 M242.368,41.19h0.02H242.368z M242.388,41.19         c0.366-0.009,0.727-0.037,1.082-0.082c0.02-0.003,0.042-0.007,0.064-0.011C243.157,41.15,242.776,41.18,242.388,41.19          M243.534,41.098h0.017H243.534z M243.551,41.098c0.029-0.006,0.06-0.01,0.091-0.014         C243.611,41.088,243.58,41.092,243.551,41.098 M243.66,41.082c0.002-0.002,0.006-0.002,0.008-0.002         C243.666,41.08,243.662,41.08,243.66,41.082 M243.694,41.076h0.005H243.694z M243.792,41.061         c0.006-0.003,0.013-0.003,0.019-0.003C243.805,41.058,243.798,41.058,243.792,41.061 M243.818,41.057         c0.008-0.001,0.016-0.003,0.024-0.005C243.834,41.054,243.826,41.055,243.818,41.057 M243.842,41.052         c0.048-0.007,0.097-0.014,0.143-0.023c0.007-0.001,0.014-0.003,0.021-0.005C243.952,41.034,243.897,41.043,243.842,41.052          M244.006,41.023c0.066-0.012,0.131-0.024,0.196-0.037C244.137,40.999,244.072,41.011,244.006,41.023 M244.202,40.986         c0.002-0.002,0.004-0.002,0.006-0.002C244.206,40.984,244.204,40.984,244.202,40.986 M244.208,40.984         c0.016-0.001,0.031-0.006,0.048-0.009C244.239,40.979,244.224,40.983,244.208,40.984 M244.256,40.976         c0.086-0.019,0.17-0.038,0.257-0.06C244.426,40.938,244.342,40.955,244.256,40.976 M244.513,40.916         c0.015-0.003,0.031-0.006,0.048-0.012C244.544,40.91,244.528,40.913,244.513,40.916 M244.561,40.904         c0.006,0,0.011-0.001,0.016-0.003C244.572,40.903,244.567,40.904,244.561,40.904 M244.577,40.901         c0.017-0.005,0.032-0.009,0.049-0.013C244.609,40.893,244.594,40.896,244.577,40.901 M244.626,40.889         c0.012-0.003,0.023-0.006,0.033-0.009C244.649,40.883,244.638,40.886,244.626,40.889 M244.659,40.88         c0.012,0,0.024-0.005,0.034-0.009C244.682,40.875,244.671,40.88,244.659,40.88 M244.693,40.871         c0.018-0.004,0.036-0.008,0.054-0.012C244.729,40.863,244.711,40.867,244.693,40.871 M244.747,40.859         c0.004-0.003,0.01-0.003,0.014-0.003C244.757,40.856,244.751,40.856,244.747,40.859 M244.761,40.856         c0.017-0.007,0.035-0.013,0.053-0.017C244.796,40.844,244.778,40.85,244.761,40.856 M244.814,40.84         c0.017-0.005,0.034-0.009,0.052-0.015C244.848,40.831,244.831,40.835,244.814,40.84 M244.866,40.825         c0.014-0.004,0.029-0.008,0.044-0.013C244.895,40.817,244.88,40.821,244.866,40.825 M244.91,40.813         c0.024-0.007,0.048-0.014,0.073-0.021C244.958,40.799,244.934,40.806,244.91,40.813 M244.983,40.791         c0.009-0.002,0.018-0.005,0.027-0.008C245.001,40.786,244.992,40.789,244.983,40.791 M245.01,40.783         c0.017-0.005,0.033-0.01,0.05-0.016C245.043,40.773,245.027,40.778,245.01,40.783 M245.06,40.768         c0.013-0.004,0.027-0.008,0.041-0.012C245.087,40.76,245.073,40.764,245.06,40.768 M245.101,40.756         c0.014-0.004,0.028-0.009,0.042-0.013C245.129,40.747,245.115,40.752,245.101,40.756 M245.143,40.743         c0.013-0.004,0.026-0.009,0.039-0.013C245.169,40.734,245.156,40.739,245.143,40.743 M245.182,40.73         c0.017-0.006,0.034-0.011,0.05-0.017C245.216,40.72,245.199,40.725,245.182,40.73 M245.232,40.714         c0.01-0.003,0.019-0.006,0.029-0.009C245.251,40.708,245.242,40.711,245.232,40.714 M245.261,40.705         c0.021-0.007,0.043-0.014,0.064-0.021C245.303,40.691,245.282,40.698,245.261,40.705 M245.325,40.684         c0.004-0.002,0.008-0.003,0.012-0.004C245.333,40.681,245.329,40.682,245.325,40.684 M245.337,40.68         c0.303-0.103,0.599-0.221,0.887-0.357C245.937,40.458,245.641,40.577,245.337,40.68"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_80_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_79_",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#SVGID_80_)"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "SVGID_81_",
  x: 241.629,
  y: 40.009,
  width: 4.978,
  height: 1.659
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_82_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_81_",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1 0 0 1 -1.248147e-005 -1.797152e-006)",
  clipPath: "url(#SVGID_82_)"
}, /*#__PURE__*/React.createElement("image", {
  overflow: "visible",
  width: 18,
  height: 6,
  xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEBBAEEAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGfAAABvAAAAiP/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAAsAFgMBIgACEQEDEQH/ xACGAAEBAQEAAAAAAAAAAAAAAAAFAAMGAQEBAAAAAAAAAAAAAAAAAAABBBAAAQIHAQAAAAAAAAAA AAAAAgMFAAEREjMEBhYRAAEBBQcFAQAAAAAAAAAAAAIBABEyAwQhMUESIkI0gcGSEzNEEgACAgID AQAAAAAAAAAAAAABAgAxIVIyAzMS/9oADAMBAAIRAxEAAABQ7rca5Bp2H//aAAgBAgABBQADTkN4 V//aAAgBAwABBQAwUmVilP/aAAgBAQABBQB+6Jy0HP17zGp0roq3beeE8P8A/9oACAECAgY/AAD1 ocX9LPNOWy61P//aAAgBAwIGPwAkdrjNBWno/HVtrn//2gAIAQEBBj8AmU1OQJKFBVMwvXUKKtrR S/BGr6gyD2UySlluGzWeQn9GLiYfaO7FvwNN4e2GC/f2b//Z",
  transform: "matrix(0.2765 0 0 -0.2765 241.6294 41.668)"
}))));

var _ref41 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_83_",
  d: "M272.455,0.377c-1.592,0.002-8.742,0.014-17.767,0.014c-3.735,0-7.636,3.111-8.861,7.623         c2.242-0.718,4.619-0.715,6.551-0.715h14.378c4.912,0,6.041-5.002,6.048-5.037c0.006-0.22-0.008-1.775-0.016-1.885H272.455z"
}));

var _ref42 = /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_84_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_83_",
  overflow: "visible"
}));

var _ref43 = /*#__PURE__*/React.createElement("rect", {
  x: 245.827,
  y: 0.377,
  clipPath: "url(#SVGID_84_)",
  fill: "url(#SVGID_85_)",
  width: 26.983,
  height: 7.637
});

var _ref44 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "SVGID_86_",
  points: "263.164,15.485 263.17,17.741 263.166,15.752       "
}));

var _ref45 = /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_87_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_86_",
  overflow: "visible"
}));

var _ref46 = /*#__PURE__*/React.createElement("rect", {
  x: 263.164,
  y: 15.485,
  clipPath: "url(#SVGID_87_)",
  fill: "url(#SVGID_88_)",
  width: 0.006,
  height: 2.256
});

var _ref47 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_89_",
  d: "M250.996,15.485h-0.002c0.558,0,12.17,0.041,12.17,0.041l0.002,0.226l-0.002-0.267H250.996z"
}));

var _ref48 = /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_90_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_89_",
  overflow: "visible"
}));

var _ref49 = /*#__PURE__*/React.createElement("rect", {
  x: 250.994,
  y: 15.485,
  clipPath: "url(#SVGID_90_)",
  fill: "url(#SVGID_91_)",
  width: 12.172,
  height: 0.267
});

var _ref50 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_92_",
  d: "M261.803,21.086c0.023-0.021,0.046-0.045,0.068-0.068C261.849,21.041,261.826,21.065,261.803,21.086          M261.871,21.018c0,0,0.002,0,0.002-0.002L261.871,21.018z M261.873,21.016c0.008-0.01,0.017-0.018,0.026-0.027         C261.89,20.998,261.881,21.006,261.873,21.016 M261.899,20.989c0.01-0.011,0.022-0.024,0.033-0.036         C261.921,20.965,261.909,20.978,261.899,20.989 M261.932,20.953c0.007-0.007,0.015-0.015,0.022-0.025         C261.947,20.936,261.938,20.947,261.932,20.953 M261.954,20.928c0.001,0,0.001-0.001,0.002-0.002c0,0,0.001-0.002,0.002-0.003         C261.956,20.924,261.956,20.926,261.954,20.928 M261.958,20.923c0.632-0.706,0.935-1.53,1.079-2.155         C262.892,19.387,262.59,20.213,261.958,20.923 M263.17,17.821v0.012v-0.026V17.821z M263.17,17.807v-0.004v-0.002V17.807z"
}));

var _ref51 = /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_93_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_92_",
  overflow: "visible"
}));

var _ref52 = /*#__PURE__*/React.createElement("rect", {
  x: 261.803,
  y: 17.801,
  clipPath: "url(#SVGID_93_)",
  fill: "url(#SVGID_94_)",
  width: 1.367,
  height: 3.285
});

var _ref53 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_95_",
  d: "M261.72,21.17c0.025-0.023,0.048-0.047,0.072-0.07C261.768,21.123,261.744,21.145,261.72,21.17          M261.792,21.1c0.004-0.005,0.008-0.01,0.011-0.014C261.8,21.09,261.794,21.096,261.792,21.1 M261.803,21.086         c0.005-0.003,0.008-0.008,0.012-0.009C261.811,21.078,261.808,21.083,261.803,21.086 M261.815,21.077         c0.007-0.008,0.016-0.016,0.025-0.026C261.831,21.061,261.822,21.069,261.815,21.077 M261.84,21.049v0.002         c0,0,0-0.002,0.002-0.002H261.84z M261.842,21.049c0.003-0.004,0.007-0.008,0.01-0.011         C261.849,21.04,261.845,21.045,261.842,21.049 M261.852,21.038c0.012-0.012,0.024-0.025,0.033-0.035         C261.876,21.013,261.864,21.026,261.852,21.038 M261.885,21.003c0.024-0.025,0.049-0.052,0.071-0.077         C261.932,20.951,261.909,20.978,261.885,21.003 M263.17,17.828v0.005v-0.012V17.828z M263.17,17.803v-0.002V17.8V17.803z"
}));

var _ref54 = /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_96_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_95_",
  overflow: "visible"
}));

var _ref55 = /*#__PURE__*/React.createElement("rect", {
  x: 261.72,
  y: 17.8,
  clipPath: "url(#SVGID_96_)",
  fill: "url(#SVGID_97_)",
  width: 1.45,
  height: 3.37
});

var _ref56 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_98_",
  d: "M254.383,22.409c0.297,0.001,0.643,0.004,1.022,0.004C255.024,22.413,254.68,22.409,254.383,22.409z          M261.84,21.049c0.041-0.041,0.079-0.081,0.116-0.123c0.634-0.711,0.936-1.539,1.081-2.158c0.11-0.472,0.129-0.83,0.133-0.935         v-0.005C263.161,18.07,263.062,19.786,261.84,21.049"
}));

var _ref57 = /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_99_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_98_",
  overflow: "visible"
}));

var _ref58 = /*#__PURE__*/React.createElement("rect", {
  x: 254.383,
  y: 17.828,
  clipPath: "url(#SVGID_99_)",
  fill: "url(#SVGID_100_)",
  width: 8.787,
  height: 4.585
});

var _ref59 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_101_",
  d: "M251.894,23.221c0.314-0.32,0.686-0.544,1.071-0.676C252.575,22.677,252.203,22.901,251.894,23.221"
}));

var _ref60 = /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_102_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_101_",
  overflow: "visible"
}));

var _ref61 = /*#__PURE__*/React.createElement("rect", {
  x: 251.894,
  y: 22.545,
  clipPath: "url(#SVGID_102_)",
  fill: "url(#SVGID_103_)",
  width: 1.071,
  height: 0.676
});

var _ref62 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_104_",
  d: "M251.607,23.569c0.045-0.066,0.093-0.128,0.143-0.189C251.7,23.44,251.652,23.503,251.607,23.569          M251.75,23.38C251.75,23.38,251.75,23.379,251.75,23.38C251.75,23.379,251.75,23.38,251.75,23.38 M251.751,23.379         c0.005-0.007,0.009-0.012,0.015-0.017C251.76,23.367,251.756,23.372,251.751,23.379 M251.766,23.362         c0.018-0.022,0.037-0.044,0.056-0.065C251.803,23.318,251.784,23.34,251.766,23.362 M251.822,23.297l0.001-0.001L251.822,23.297          M251.823,23.296c0.002-0.003,0.005-0.005,0.007-0.007C251.828,23.291,251.825,23.293,251.823,23.296 M251.83,23.289         c0.021-0.023,0.042-0.046,0.064-0.068c0.309-0.32,0.681-0.544,1.071-0.676c0.082-0.028,0.164-0.051,0.247-0.07         C252.705,22.589,252.216,22.862,251.83,23.289 M253.212,22.475L253.212,22.475L253.212,22.475z M253.213,22.475         c0.012-0.003,0.023-0.005,0.035-0.008C253.236,22.47,253.225,22.472,253.213,22.475"
}));

var _ref63 = /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_105_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_104_",
  overflow: "visible"
}));

var _ref64 = /*#__PURE__*/React.createElement("rect", {
  x: 251.607,
  y: 22.467,
  clipPath: "url(#SVGID_105_)",
  fill: "url(#SVGID_106_)",
  width: 1.641,
  height: 1.102
});

var _ref65 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_107_",
  d: "M249.291,37.788c-0.008,0.011-0.016,0.023-0.024,0.035c0.035-0.05,0.07-0.1,0.105-0.151         C249.346,37.711,249.318,37.75,249.291,37.788 M249.372,37.672c0.01-0.013,0.019-0.026,0.028-0.039         C249.391,37.646,249.382,37.659,249.372,37.672 M249.4,37.633c0.007-0.011,0.014-0.021,0.021-0.032         C249.414,37.612,249.407,37.622,249.4,37.633 M249.421,37.601c0.015-0.021,0.03-0.043,0.044-0.065         c0.002-0.003,0.005-0.007,0.007-0.011C249.455,37.55,249.438,37.576,249.421,37.601 M249.472,37.525         c0.001-0.001,0.001-0.002,0.002-0.003C249.473,37.523,249.473,37.524,249.472,37.525 M249.474,37.522         c0.007-0.008,0.011-0.018,0.017-0.028C249.485,37.504,249.48,37.514,249.474,37.522 M250.522,35.282         c0.004-0.012,0.007-0.022,0.01-0.03C250.529,35.26,250.526,35.27,250.522,35.282 M250.532,35.252         c0.003-0.013,0.007-0.025,0.01-0.036C250.539,35.227,250.535,35.239,250.532,35.252 M250.542,35.216         c0.006-0.018,0.011-0.036,0.016-0.054c0.014-0.048,0.029-0.097,0.043-0.148C250.582,35.081,250.562,35.149,250.542,35.216          M250.601,35.014c0.004-0.014,0.008-0.027,0.012-0.041C250.609,34.987,250.605,35,250.601,35.014 M250.613,34.973         c0.001-0.006,0.003-0.011,0.004-0.019C250.616,34.962,250.614,34.967,250.613,34.973 M250.617,34.954         c0.088-0.315,0.162-0.645,0.223-0.986C250.779,34.309,250.705,34.638,250.617,34.954 M250.84,33.968         c0-0.002,0.001-0.004,0.001-0.006C250.841,33.964,250.84,33.966,250.84,33.968 M250.841,33.962         c0.003-0.019,0.006-0.037,0.009-0.055C250.847,33.925,250.844,33.943,250.841,33.962 M250.85,33.907         c0.001-0.007,0.002-0.014,0.004-0.022C250.852,33.893,250.851,33.9,250.85,33.907 M250.854,33.885         c0.002-0.012,0.004-0.025,0.006-0.038C250.858,33.86,250.856,33.873,250.854,33.885 M250.86,33.847         c0.002-0.013,0.004-0.025,0.007-0.037C250.864,33.822,250.862,33.834,250.86,33.847 M250.867,33.81         c0.001-0.008,0.001-0.015,0.003-0.022C250.868,33.795,250.868,33.802,250.867,33.81 M250.87,33.788         c0.003-0.018,0.006-0.037,0.008-0.056C250.876,33.751,250.873,33.77,250.87,33.788 M250.986,32.831         c-0.026,0.309-0.062,0.61-0.108,0.901c0.048-0.3,0.085-0.611,0.111-0.93C250.988,32.812,250.986,32.822,250.986,32.831          M250.989,32.802c0.001-0.016,0.003-0.032,0.004-0.048C250.992,32.77,250.99,32.786,250.989,32.802 M251.032,25.575v0.47v0.112         c0.001-0.252,0.001-0.457,0.001-0.602v-0.047C251.033,25.53,251.032,25.551,251.032,25.575"
}));

var _ref66 = /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_108_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_107_",
  overflow: "visible"
}));

var _ref67 = /*#__PURE__*/React.createElement("rect", {
  x: 249.267,
  y: 25.508,
  clipPath: "url(#SVGID_108_)",
  fill: "url(#SVGID_109_)",
  width: 1.766,
  height: 12.315
});

var _ref68 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_110_",
  d: "M251.035,25.438c-0.002,0.04-0.003,0.078-0.003,0.117c0,0.31,0,0.906-0.002,1.615v0.838         c0.001-0.701,0.002-1.361,0.002-1.851v-0.112v-0.47c0-0.024,0.001-0.045,0.001-0.067c0.002-0.052,0.003-0.102,0.005-0.152         C251.037,25.383,251.035,25.411,251.035,25.438"
}));

var _ref69 = /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_111_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_110_",
  overflow: "visible"
}));

var _ref70 = /*#__PURE__*/React.createElement("rect", {
  x: 251.03,
  y: 25.356,
  clipPath: "url(#SVGID_111_)",
  fill: "url(#SVGID_112_)",
  width: 0.008,
  height: 2.652
});

var _ref71 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_113_",
  d: "M246.224,40.322c1.197-0.558,2.237-1.392,3.043-2.499c0.001-0.002,0.004-0.006,0.007-0.01         C248.466,38.926,247.423,39.76,246.224,40.322 M249.274,37.813c0.005-0.008,0.01-0.015,0.017-0.025         C249.284,37.796,249.279,37.805,249.274,37.813 M249.491,37.494c-0.009,0.016-0.017,0.028-0.026,0.042         c0.062-0.093,0.121-0.187,0.179-0.284C249.594,37.334,249.544,37.415,249.491,37.494 M249.644,37.252         c0.007-0.011,0.014-0.023,0.021-0.035C249.658,37.229,249.651,37.241,249.644,37.252 M249.665,37.217         c0.002-0.003,0.005-0.007,0.007-0.011C249.67,37.21,249.667,37.214,249.665,37.217 M249.672,37.206         c0.343-0.576,0.63-1.217,0.85-1.924c0.009-0.03,0.017-0.057,0.026-0.086C250.324,35.937,250.029,36.605,249.672,37.206          M250.548,35.196c0.004-0.012,0.007-0.022,0.01-0.034C250.555,35.174,250.552,35.184,250.548,35.196 M251.032,31.604         c0.003,0.424-0.013,0.832-0.046,1.227c0.003-0.026,0.005-0.051,0.007-0.077C251.021,32.385,251.035,31.999,251.032,31.604         c-0.002-0.728-0.002-2.238-0.002-3.596V27.17C251.03,28.686,251.029,30.721,251.032,31.604 M251.035,25.438         c0-0.017,0.001-0.033,0.002-0.05C251.036,25.405,251.035,25.421,251.035,25.438 M251.038,25.356         c-0.001,0.01-0.001,0.022-0.001,0.032c0.002-0.081,0.008-0.161,0.015-0.239C251.046,25.217,251.04,25.286,251.038,25.356          M251.054,25.13L251.054,25.13 M251.052,25.149c0.001-0.006,0.001-0.013,0.002-0.019         C251.053,25.136,251.053,25.143,251.052,25.149 M251.054,25.13L251.054,25.13 M251.054,25.129         C251.054,25.129,251.054,25.129,251.054,25.129S251.054,25.129,251.054,25.129L251.054,25.129 M251.054,25.129L251.054,25.129          M251.054,25.129c0.008-0.074,0.018-0.147,0.029-0.218C251.071,24.982,251.062,25.055,251.054,25.129"
}));

var _ref72 = /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_114_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_113_",
  overflow: "visible"
}));

var _ref73 = /*#__PURE__*/React.createElement("rect", {
  x: 246.224,
  y: 24.911,
  clipPath: "url(#SVGID_114_)",
  fill: "url(#SVGID_115_)",
  width: 4.859,
  height: 15.411
});

var _ref74 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_116_",
  d: "M238.465,41.19h0.049H238.465z M239.751,41.192l-0.927-0.002L239.751,41.192z"
}));

var _ref75 = /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_117_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_116_",
  overflow: "visible"
}));

var _ref76 = /*#__PURE__*/React.createElement("rect", {
  x: 238.465,
  y: 41.19,
  clipPath: "url(#SVGID_117_)",
  fill: "url(#SVGID_118_)",
  width: 1.286,
  height: 0.002
});

var _ref77 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_119_",
  d: "M239.751,41.192l2.325,0.003L239.751,41.192z"
}));

var _ref78 = /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_120_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_119_",
  overflow: "visible"
}));

var _ref79 = /*#__PURE__*/React.createElement("rect", {
  x: 240.912,
  y: 40.031,
  clipPath: "url(#SVGID_120_)",
  fill: "url(#SVGID_121_)",
  width: 0.003,
  height: 2.325
});

var _ref80 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#SVGID_2_)"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_122_",
  d: "M238.448,41.19h0.017H238.448h0.066h0.31c-0.121,0-0.246-0.003-0.376-0.003V41.19z M243.642,41.084         c0.007-0.002,0.013-0.002,0.018-0.002C243.655,41.082,243.649,41.082,243.642,41.084 M243.668,41.08         c0.009-0.002,0.018-0.002,0.026-0.004C243.686,41.078,243.677,41.078,243.668,41.08 M243.699,41.076         c0.031-0.006,0.063-0.009,0.093-0.016C243.76,41.067,243.73,41.07,243.699,41.076 M243.811,41.058         c0.003-0.001,0.006-0.001,0.007-0.001C243.817,41.057,243.814,41.057,243.811,41.058 M249.382,37.657         c-0.03,0.043-0.061,0.088-0.091,0.131c0.059-0.082,0.117-0.167,0.174-0.252C249.437,37.577,249.41,37.616,249.382,37.657          M250.558,35.162c0.212-0.712,0.359-1.49,0.428-2.331C250.91,33.663,250.77,34.44,250.558,35.162 M263.17,17.821v-0.018V17.821z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_123_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_122_",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#SVGID_123_)"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "SVGID_124_",
  x: 238.035,
  y: 17.334,
  width: 25.44,
  height: 24.334
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_125_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_124_",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1 0 0 1 -1.543008e-005 -1.797152e-006)",
  clipPath: "url(#SVGID_125_)"
}, /*#__PURE__*/React.createElement("image", {
  overflow: "visible",
  width: 92,
  height: 88,
  xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEBBAEEAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAJ2AAADNgAABGT/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAF4AXgMBIgACEQEDEQH/ xACiAAACAwEBAAAAAAAAAAAAAAAAAQIDBQQGAQEBAQEBAQAAAAAAAAAAAAAAAgEDBQQQAAEDAgUE AwEAAAAAAAAAAAABERIDEwIEBQYWEBQlNSAiMjARAAADBwMEAwEAAAAAAAAAAAABAjCRMpKy0jMD gwQhIhMFEVESQhIAAAQDBgYDAAAAAAAAAAAAAAECMiCRA3KSsjOTBBFBUWEicyFCE//aAAwDAQAC EQMRAAAAuMR+r5e28V42niyZsvGbNl48mbHZ53SmvPub7c4ObISk2RlJsjJyYtLg0YrHdpfKstZU 7GyuU2VylJkNHh0I6ZrtL4VFoVuwK3MZBzCHfx90deMZfzoYIYIYIYHbxdsdeI1ybyDXDINcMg1w yDXDI7eq+en/2gAIAQIAAQUAs0yzTLNMs0yzTMdKmifGp+fjU/Pxqfn41PzeLxeLxeMdV0//2gAI AQMAAQUAvVC9UL1QvVS9VKdaouJyQ445SX7SJEiQ5RX7OOOOOUV+7jjjjlBfv2qnaqdqp2qnaqUs sqYv/9oACAEBAAEFAOW6wct1g5Zq5yvVxN16ucq1Y5TqxyjVjk+qnJ9VOTaoZbXM/U0/onROiCCC dMl6dhhhEERRHEQRBEEQRDJengRIiYRMImEiJhEwiIJhMkniIkSJEiRIkRMImERDJp4mJEiRIkSJ EiMMZRPFxIkSJEiRIkRhjKJ4yJEiRIkRhhhhjKp41iIwwwwwwwwxlfXfzyvrv55X11vb5b2+W9vl vb5b2+W9vlvb5b2+W9vlvb5b2+UcGj9r/9oACAECAgY/AGJkGJkGJkGJkGJkC4JS5PLuURW0YiiK 2jEURW0YiiK2jEQZVuhlW6GVboZVuhlW6C8Kjk/XuP/aAAgBAwIGPwB6ph6ph6ph6ph6pg+K1MXz 6JOI7C8JxH66mE4j9dTAcR+urgMZu31CGbt9Qhm7fUIZu31CGbt9QgZ/rQPwqF8L6pMh/9oACAEB AQY/AItOQhFpyEItOQhFpyEIkSEIkSEIkSEIkSEIkSEIkSkIkSjm8hRp8mh4vH29O9X5P5aey2Kz aey2Kzaey2Kzaex2Kzaew2azac/ZrNpz9ms2nO2azac7ZrNpztmsxkU5doyKcu0ZFOXaMinLtGRT l2jIpy7RkU5doyKcu0ZFOXaMinLtGRTl2jkFprUeif48x93Tr2/z9j//2Q==",
  transform: "matrix(0.2765 0 0 -0.2765 238.0347 41.668)"
}))));

var _ref81 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#SVGID_2_)"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_126_",
  d: "M251.031,25.596l-0.001,1.574c0.002-0.709,0.002-1.305,0.002-1.615c0-0.039,0.001-0.077,0.003-0.117         C251.032,25.491,251.031,25.543,251.031,25.596 M251.53,23.682c0.026-0.039,0.049-0.076,0.077-0.113         c0.417-0.6,1.017-0.971,1.641-1.102c0.048-0.01,0.095-0.019,0.14-0.027C252.679,22.545,251.982,22.959,251.53,23.682          M261.684,21.202c0.013-0.01,0.024-0.022,0.036-0.032c0.003-0.003,0.006-0.006,0.01-0.01         C261.714,21.174,261.7,21.187,261.684,21.202 M261.73,21.16c0.002-0.002,0.006-0.004,0.009-0.007         C261.735,21.156,261.732,21.158,261.73,21.16 M261.739,21.153c0.003-0.006,0.009-0.01,0.012-0.013         C261.748,21.143,261.742,21.147,261.739,21.153 M261.751,21.14c0.032-0.03,0.061-0.062,0.089-0.091         C261.812,21.078,261.783,21.11,261.751,21.14 M238.448,41.188L238.448,41.188 M242.019,22.688c0,3.242,0.021,5.22,0.021,8.09         c0,8.547-3.438,10.119-3.592,10.41c0,0,0.007,0.003,0.017,0.003h0.049l-0.066-0.003c0.13,0,0.255,0.003,0.376,0.003l0.927,0.002         c-0.4-0.002-0.814-0.005-1.303-0.005c3.06-0.003,5.863-3.696,6.365-6.106c0.673-3.232,0.629-6.059,0.629-11.419         c0-1.001-0.003-4.275-0.007-7.284C243.418,17.299,242.019,19.13,242.019,22.688 M263.17,17.828v-0.007v-0.018V17.8v-0.059         l-0.004-1.989L263.17,17.828z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_127_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_126_",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#SVGID_127_)"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "SVGID_128_",
  x: 238.035,
  y: 15.398,
  width: 25.44,
  height: 26.27
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_129_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_128_",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1 0 0 1 -1.543008e-005 -1.797152e-006)",
  clipPath: "url(#SVGID_129_)"
}, /*#__PURE__*/React.createElement("image", {
  overflow: "visible",
  width: 92,
  height: 95,
  xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEBBAEEAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAJpAAADEQAAA/b/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAGIAXgMBIgACEQEDEQH/ xACcAAACAwEBAAAAAAAAAAAAAAAAAQIDBQQGAQEAAwEBAAAAAAAAAAAAAAAAAQIDBAUQAAEDAQcF AAMAAAAAAAAAAAABERIDIAIyEwQFFhAwIiU1MTQGEQAAAwgBAwUAAAAAAAAAAAAAATIwApKyA4ME RAUiQhMRIcESNBIAAgAGAgIDAQAAAAAAAAAAAQIAIJEycrIDcxFBUWGxgv/aAAwDAQACEQMRAAAA uMR+r5e28Vw2niyRsvGaNl48kbHZ53Srbz7m9s4ObISk0RlJojJyQtLg0aWx3aXyrLWVOxorlNlc pSRDR4dCmma7S+FRaFbsCtzEQcwh38fdTXjGX50MEMEMEMDs4+2mvEBfEAAAAAADt4u2mtwGPWAA AAAAB0BW/wD/2gAIAQIAAQUAyaZk0zJpmTTMmmX6VNEs1MNmphs1MNmphs1MNm/+P//aAAgBAwAB BQDOqGdUM6oZ1UzqpTrVFvOSHHHKS+UiRIkOUV8nHHHHKK+bjjjjlBfOzQx2aeL/2gAIAQEAAQUA 5bvBy3eDlm7nK93E/q93OVbscp3Y5RuxyfdTk+6nJt0NNvmvqbf0TonRBBBOmi+OwwwiCIojiIIg iCIIhovjwIkRLol0S6REuiXREEumiT1ESJEiRIkSIl0S6Iho09VEiRIkSJEiRGGNInq4kSJEiRIk SIwxpE9ZEiRIkSIwwwwxpU9axEYYYYYYYYY0vzu3pfndvS/O7el+d26P6n//2gAIAQICBj8AsWkW LSLFpFi0ixaQPCrcvr7EwzTYTDNNhMM02EwzTYTDNNhN/S/sf//aAAgBAwIGPwC9qxe1YvasXtWL 2rB8u1j+/hTMcH1Mx6+TUzHr5NDMevl0Mx6+XQzHB9TH/9oACAEBAQY/AFU4CCqcBBVOAgqnAQU5 AQU5AQU5AQU5AQU5AQU5CQU5CM3IeN3yUPF4+n263vqfq05KxObTkrE5tOSsTm05GxObTkLM5tM+ zObTPszm0zrM5tM6zObTOszm0zrM5jSGkNIaQ0hpDSGkNIaQ0hk/l7EoV3/A/9k=",
  transform: "matrix(0.2765 0 0 -0.2765 238.0347 41.668)"
}))));

var _ref82 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#SVGID_2_)"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_130_",
  d: "M245.435,16.378c0.004,3.009,0.007,6.283,0.007,7.284c0,5.36,0.044,8.187-0.629,11.419         c-0.502,2.41-3.305,6.104-6.365,6.106c0.489,0,0.903,0.003,1.303,0.005l2.325,0.003c0.533,0,1.056-0.036,1.566-0.111         c0.007-0.002,0.013-0.002,0.018-0.002c0.002-0.002,0.006-0.002,0.008-0.002c0.009-0.002,0.018-0.002,0.026-0.004h0.005         c0.031-0.006,0.063-0.009,0.093-0.016c0.006-0.003,0.013-0.003,0.019-0.003c0.003-0.001,0.006-0.001,0.007-0.001         c0.85-0.141,1.658-0.385,2.406-0.734c1.208-0.563,2.259-1.408,3.067-2.534c0.03-0.043,0.061-0.088,0.091-0.131         c0.028-0.041,0.055-0.08,0.083-0.121c0.458-0.691,0.827-1.483,1.093-2.374c0.212-0.722,0.352-1.499,0.428-2.331         c0.033-0.395,0.049-0.803,0.046-1.227c-0.003-0.883-0.002-2.918-0.002-4.434l0.001-1.574c0-0.053,0.001-0.105,0.004-0.158         c0.004-0.185,0.02-0.359,0.048-0.527c0.074-0.481,0.234-0.891,0.447-1.229c0.452-0.723,1.149-1.137,1.858-1.242         c0.113-0.018,0.225-0.027,0.335-0.031h0.66c0.328,0,0.715,0.004,1.142,0.004c0.757,0.004,1.645,0.005,2.583,0.005         c1.698,0,2.827-0.523,3.576-1.216c0.056-0.049,0.108-0.102,0.156-0.153c1.222-1.263,1.321-2.979,1.33-3.221l-0.004-2.076         l-0.002-0.226c0,0-11.612-0.041-12.17-0.041C249.012,15.485,247.03,15.647,245.435,16.378"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_131_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_130_",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#SVGID_131_)"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "SVGID_132_",
  x: 238.035,
  y: 15.122,
  width: 25.44,
  height: 26.546
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_133_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_132_",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1 0 0 1 -1.543008e-005 -1.797152e-006)",
  clipPath: "url(#SVGID_133_)"
}, /*#__PURE__*/React.createElement("image", {
  overflow: "visible",
  width: 92,
  height: 96,
  xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEBBAEEAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAKCAAADMQAABEj/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAGUAXgMBIgACEQEDEQH/ xACqAAEAAwEBAQAAAAAAAAAAAAAAAQMFAgQGAQEBAQEBAQAAAAAAAAAAAAAAAQIDBAUQAAIAAwYG AgMBAAAAAAAAAAASAREDIRMEBRYmIDACMiU1ECIxFBUGEQAAAgcHAgcAAAAAAAAAAAAAATAyQpKi AwQCshODs4QFESIhUYGhEiNzEgAABAMIAQUBAAAAAAAAAAAAAQIyIJGyETGhcgNzREVR8EFhcWI0 /9oADAMBAAIRAxEAAADphz9b5O4w5NycOU25xJTbYss7Xu+Y1c7wljtz4WSlc9ynE9ynE9zc8aub qc95S5vjUtkqWrK5sJXNkpXpeHSx0znoa40LyULpKVqyqbJSrQ8nv59fM6XPLocuhy6HLpZz7fJ7 cdfENcgAAAHt8Xtx19Q8/uAAAAXmd//aAAgBAgABBQC5pFzSLmkXNIuaRUo04dPDU7eGp2zJk/mp 28NTt4anbw9X4//aAAgBAwABBQC+ql9VL+qX9Uv6pTr1Y9TDDDDFKP2cYYYYo9X3tLS0nEnEoRi8 +Gh38NDvsLCwsLCnKf8A/9oACAEBAAEFANYZ0awzk1fnJq/OTV+cmrs5NXZwatzg1bnBqzNzVebm E/0GY1cs5ECHxgPSSJEiRIkSJEIEiRgPSKKKKKKKKKKKYCHhVFFFFFFFFFFMDDw6iiiiiiiiiimC h4hRRRRRRRRRRTBw8ShdiF2XZdiCREiJESJg+nxaiiiiiiiiiimF6fG8vC+u5eF9dy8L67b5t82+ bfNvm3zb5t82+bfNvlH+P+r/AP/aAAgBAgIGPwBiZBiZBiZBiZBiZArEJcj2/RRFnRUURZ0VFEWd FRRFnRUURZ0VEOUOUOUOUOUOTeV/36sH/9oACAEDAgY/AHqmHqmHqmHqmHqmDtWpizv8JOI8mpSc R7epQcR7WrQqI9vVoOI9vVoMdfiOvxHX4jr8R1+IP+Fqm3tPDz8D/9oACAEBAQY/AFpbhBaW4QWl uEFpbhBaW4QWluEFpbhBaW4QWluEFpbhBaW4Qr6m3asYlNg4fSz4fZbOza6+iTlttqGk5bbahpOV 2+oaTlNvqGk5LIvmk5HIvmk5Avxvmkr8m+aSuyb5pK7Jvmkrsm+YajDUYajDUYajDUYajDUYajDU YajFRh/LB7MZbz7fcf/Z",
  transform: "matrix(0.2765 0 0 -0.2765 238.0347 41.668)"
}))));

var _ref83 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#SVGID_2_)"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "SVGID_134_",
  x: -410,
  y: -501,
  width: 1920,
  height: 1080
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_135_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_134_",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#SVGID_135_)",
  fill: "#4D4D4F",
  d: "M617.03,62.136v13.811c0,2.184,1.754,2.604,3.403,2.325V64.463       C620.434,62.276,618.679,61.859,617.03,62.136 M618.618,55.426c-1.146,0-2.075,0.951-2.075,2.125c0,1.169,0.929,2.121,2.075,2.121       c1.146,0,2.075-0.952,2.075-2.121C620.693,56.377,619.764,55.426,618.618,55.426 M635.705,73.673       c-0.359,0.532-1.793,2.078-3.992,1.964c-2.58-0.13-4.181-1.847-4.181-5.432c0-3.478,1.692-5.249,4.181-5.249       c2.132,0,3.505,1.163,4.059,1.782c0.462-0.217,1.321-1.086,1.321-1.964c0-1.676-2.861-2.866-5.271-2.866       c-4.501,0-7.79,3.151-7.79,8.297c0,5.955,3.255,8.425,7.79,8.425c3.062,0,5.304-1.583,5.304-2.615       C637.126,75.065,636.132,74.103,635.705,73.673 M606.174,61.778c-4.824,0-6.693,3.094-6.693,7.16v9.329       c1.65,0.276,3.404-0.142,3.404-2.328v-7.001c0-2.441,1.121-4.114,3.289-4.114c2.167,0,3.289,1.673,3.289,4.114v7.001       c0,2.187,1.755,2.604,3.404,2.328v-9.329C612.867,64.872,610.996,61.778,606.174,61.778 M591.912,64.472v7.002       c0,2.441-1.123,4.112-3.29,4.112c-2.168,0-3.29-1.671-3.29-4.112v-7.002c0-2.187-1.755-2.604-3.402-2.328v9.33       c0,4.065,1.869,7.159,6.692,7.159c4.822,0,6.693-3.094,6.693-7.159v-9.33C593.664,61.868,591.912,62.285,591.912,64.472"
}));

var _ref84 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_136_",
  d: "M611.439,12.055v18.827c0,8.481-2.119,11.938-7.308,11.938c-9.526,0-9.794-13.891-9.794-14.032V18.395         c0-4.089,2.209-5.95,4.261-5.95c4.104,0,4.222,5.342,4.222,5.95v1.645h3.823v-1.645c0-0.444-0.049-2.781-1.036-5.049         c-1.328-3.048-3.816-4.727-7.009-4.727c-4.019,0-8.084,3.359-8.084,9.776v10.393c0,4.968,2.446,17.855,13.617,17.855         c11.132,0,11.132-11.861,11.132-15.762V12.055c0-3.3,0.823-7.235,4.747-7.235c3.729,0,4.511,3.854,4.511,7.084v2.126h3.825         v-2.126c0-10.122-6.379-10.907-8.336-10.907C614.645,0.997,611.439,5.129,611.439,12.055"
}));

var _ref85 = /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_137_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_136_",
  overflow: "visible"
}));

var _ref86 = /*#__PURE__*/React.createElement("rect", {
  x: 590.515,
  y: 0.997,
  clipPath: "url(#SVGID_137_)",
  fill: "url(#SVGID_138_)",
  width: 37.832,
  height: 45.647
});

var _ref87 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_139_",
  d: "M624.521,11.904v11.894c0,8.856-4.047,13.347-12.024,13.347c-5.092,0-5.854-5.239-5.854-8.364V18.395         h-3.823v10.386c0,7.633,3.617,12.19,9.677,12.19c10.072,0,15.85-6.261,15.85-17.174V11.904H624.521z"
}));

var _ref88 = /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_140_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_139_",
  overflow: "visible"
}));

var _ref89 = /*#__PURE__*/React.createElement("rect", {
  x: 602.82,
  y: 11.904,
  clipPath: "url(#SVGID_140_)",
  fill: "url(#SVGID_141_)",
  width: 25.526,
  height: 29.067
});

var _ref90 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#SVGID_2_)"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "SVGID_142_",
  x: -410,
  y: -501,
  width: 1920,
  height: 1080
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_143_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_142_",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#SVGID_143_)",
  fill: "#4E4E4E",
  d: "M780.488,71.339V65.76c0-1.946-0.895-3.277-2.621-3.277       c-1.729,0-2.621,1.331-2.621,3.277v5.579c0,1.738-1.398,2.072-2.712,1.851v-7.43c0-3.242,1.49-5.705,5.333-5.705       c3.842,0,5.332,2.463,5.332,5.705v7.43C781.887,73.411,780.488,73.077,780.488,71.339"
}), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#SVGID_143_)",
  fill: "#4E4E4E",
  d: "M787.937,54.992c-0.912,0-1.652,0.76-1.652,1.69       c0,0.937,0.74,1.693,1.652,1.693c0.913,0,1.653-0.757,1.653-1.693C789.59,55.752,788.85,54.992,787.937,54.992"
}), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#SVGID_143_)",
  fill: "#4E4E4E",
  d: "M786.67,60.337v11.002c0,1.738,1.398,2.072,2.712,1.851v-11       C789.382,60.448,787.982,60.118,786.67,60.337"
}), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#SVGID_143_)",
  fill: "#4E4E4E",
  d: "M761.26,62.199v5.579c0,1.947,0.896,3.278,2.623,3.278       c1.725,0,2.619-1.331,2.619-3.278v-5.579c0-1.74,1.399-2.073,2.714-1.852v7.431c0,3.24-1.491,5.707-5.333,5.707       c-3.844,0-5.334-2.467-5.334-5.707v-7.431C759.862,60.126,761.26,60.459,761.26,62.199"
}), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#SVGID_143_)",
  fill: "#4E4E4E",
  d: "M800.461,54.972v6.175c-0.189-0.151-0.832-0.983-3.021-0.983       c-0.61,0-5.476,0-5.476,6.869c0,6.854,5.218,6.457,5.218,6.457c2.194,0,3.145-0.928,3.454-1.217       c0.575,1.359,2.537,0.954,2.537,0.954V56.823C803.173,55.082,801.773,54.752,800.461,54.972 M800.461,69.614       c0,0.392-0.227,0.726-0.693,1.021c-0.498,0.317-1.143,0.476-1.915,0.476c-0.572,0-3.021,0.017-3.021-4.208       c0-1.438,0.192-4.339,2.97-4.339c1.629,0,2.571,1.142,2.66,1.25V69.614"
}), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#SVGID_143_)",
  fill: "#4E4E4E",
  d: "M808.324,67.369h8.108c0,0,1.314-7.282-5.104-7.282       c-6.121,0-5.81,6.615-5.81,6.615c0,4.742,2.668,6.712,6.381,6.712c2.509,0,4.348-1.262,4.348-2.083       c0-0.755-0.815-1.524-1.164-1.865c-0.294,0.423-1.467,1.564-3.271,1.564C808.841,71.03,808.324,68.38,808.324,67.369        M808.334,65.198c0.096-0.833,0.657-2.787,2.894-2.787c2.604,0,2.587,2.442,2.601,2.787H808.334z"
}), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#SVGID_143_)",
  fill: "#4E4E4E",
  d: "M825.297,63.71c0,0-0.785-0.78-1.856-0.78c-1.024,0-1.857,0.343-1.857,1.73       v8.574h-2.712V64.66c0-2.742,1.688-4.366,4.338-4.366c0.868,0,2.068,0.304,2.587,0.774c0.394,0.357,0.361,0.949,0.104,1.563       C825.76,62.965,825.443,63.494,825.297,63.71"
}), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#SVGID_143_)",
  fill: "#4E4E4E",
  d: "M833.979,60.117c-2.194,0-3.145,0.927-3.455,1.214       c-0.575-1.358-2.536-0.953-2.536-0.953v18.255h2.711v-6.174c0.189,0.148,0.832,0.984,3.021,0.984c0.61,0,5.475,0,5.475-6.87       C839.195,59.72,833.979,60.117,833.979,60.117 M833.359,71.041c-1.63,0-2.572-1.144-2.66-1.25v-5.799       c0-0.392,0.227-0.727,0.692-1.023c0.5-0.316,1.143-0.477,1.915-0.477c0.574,0,3.021-0.016,3.021,4.21       C836.328,68.14,836.135,71.041,833.359,71.041"
}));

var _ref91 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_144_",
  d: "M776.226,20.984c-0.144,0.865-0.047,1.753,0.47,2.463l2.658,3.646c0.679,0.901,1.054,2.019,1.054,3.148         v5.482c0,0.953,0.58,1.618,1.252,2.388c0.85,0.963,1.664,1.835,2.897,2.753V30.242c0-2.095-0.694-4.17-1.956-5.841l-5.465-7.211         C776.593,18.882,776.43,19.754,776.226,20.984 M814.39,24.566c-1.262,1.672-1.956,3.746-1.956,5.842V41.23         c0.867-0.594,2.138-1.778,2.897-2.605c0.679-0.68,1.252-1.435,1.252-2.388v-5.829c0-1.13,0.374-2.248,1.054-3.148l2.783-4.066         c0.516-0.711,0.742-1.722,0.593-2.587c-0.178-1.03-0.461-2.558-0.977-3.875L814.39,24.566z M779.129,13.781         c-0.506,0.888-0.278,2.063,0.348,2.873l5.331,6.898c1.367,1.808,2.12,4.052,2.12,6.318v11.506c0,0.747,0.41,1.435,1.069,1.788         c-0.055,0.021,2.052,1.021,3.08,1.334V29.87c0-3.231-1.073-6.432-3.021-9.012l-7.28-9.555         C780.413,11.73,779.584,12.977,779.129,13.781 M809.061,20.858c-1.949,2.58-3.022,5.781-3.022,9.012v14.741         c1.487-0.476,3.074-1.293,3.074-1.293c0.659-0.354,1.069-1.04,1.069-1.786l0.006-11.662c0-2.266,0.752-4.51,2.118-6.318         l5.585-7.299c0.624-0.81,0.737-1.906,0.238-2.799c-0.451-0.804-0.964-1.548-1.611-2.374L809.061,20.858z M804.064,16.93         c-2.739,3.629-4.248,8.131-4.248,12.679v16.165c0.769-0.022,2.533-0.218,2.973-0.343c0.682-0.124,1.178-0.716,1.178-1.407V29.609         c0-3.582,1.188-7.128,3.346-9.984l6.904-9.034c0.498-0.652,0.46-1.584-0.135-2.151c-0.664-0.633-1.369-1.158-2.192-1.745         L804.064,16.93z M783.283,8.488c-0.596,0.566-0.6,1.522-0.1,2.175l6.967,8.962c2.156,2.856,3.346,6.402,3.346,9.984v14.409         c0,0.693,0.511,1.304,1.193,1.426c0.584,0.102,2.076,0.325,2.955,0.33V29.609c0-4.548-1.507-9.05-4.246-12.679L785.51,6.688         C784.72,7.273,783.947,7.854,783.283,8.488"
}));

var _ref92 = /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_145_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_144_",
  overflow: "visible"
}));

var _ref93 = /*#__PURE__*/React.createElement("rect", {
  x: 776.082,
  y: 6.688,
  clipPath: "url(#SVGID_145_)",
  fill: "url(#SVGID_146_)",
  width: 45.08,
  height: 39.085
});

var _ref94 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_147_",
  d: "M787.439,5.466l11.301,15.101l11.238-15.113c-3.593-1.946-7.182-2.937-11.238-2.937         C794.615,2.517,790.929,3.536,787.439,5.466"
}));

var _ref95 = /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_148_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_147_",
  overflow: "visible"
}));

var _ref96 = /*#__PURE__*/React.createElement("rect", {
  x: 787.439,
  y: 2.517,
  clipPath: "url(#SVGID_148_)",
  fill: "url(#SVGID_149_)",
  width: 22.538,
  height: 18.05
});

var _ref97 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#SVGID_2_)"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "SVGID_150_",
  x: -410,
  y: -501,
  width: 1920,
  height: 1080
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_151_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_150_",
  overflow: "visible"
})), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#SVGID_151_)",
  fill: "#4D4D4F",
  d: "M1203.75,68.739c-0.069,1.543-5.344,3.104-5.344-0.028       c0-2.875,5.344-2.493,5.344-2.493V68.739z M1206.332,61.903c-0.167-0.646-0.756-2.922-4.911-2.922       c-2.705,0-4.206,0.909-4.518,1.137c-0.367,0.265-0.553,0.563-0.553,0.89c0,0.202,0.027,0.46,0.166,0.754       c0.291,0.612,0.73,0.948,0.73,0.948s1.873-1.18,3.899-1.18c1.03,0,1.72,0.191,2.06,0.556c0.562,0.599,0.517,1.809,0.517,1.809       c-0.096-0.004-0.195-0.005-0.301-0.005c0,0-7.894-0.44-7.894,4.961c0,0.807,0.139,1.488,0.413,2.018       c0.274,0.525,1.107,2.092,3.972,2.092c2.621,0,3.604-1.057,4.003-1.396c0.327,0.951,1.02,1.563,2.658,1.252v-8.763       C1206.574,63.251,1206.493,62.523,1206.332,61.903"
}), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#SVGID_151_)",
  fill: "#4D4D4F",
  d: "M1217.039,62.604c0,0-0.833-0.827-1.969-0.827       c-1.087,0-1.972,0.363-1.972,1.838v9.097h-2.878v-9.097c0-2.912,1.791-4.633,4.604-4.633c0.922,0,2.195,0.321,2.745,0.82       c0.417,0.379,0.384,1.008,0.112,1.658C1217.531,61.813,1217.196,62.375,1217.039,62.604"
}), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#SVGID_151_)",
  fill: "#4D4D4F",
  d: "M1172.511,70.574c-2.457,0-3.305-2.022-3.305-4.521       c0-2.497,0.848-4.522,3.305-4.522s3.305,2.025,3.305,4.522C1175.815,68.552,1174.968,70.574,1172.511,70.574 M1172.511,58.981       c-4.131,0-6.304,3.166-6.304,7.071c0,3.904,2.173,7.071,6.304,7.071c4.132,0,6.306-3.167,6.306-7.071       C1178.816,62.147,1176.643,58.981,1172.511,58.981"
}), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#SVGID_151_)",
  fill: "#4D4D4F",
  d: "M1187.338,70.577c-1.73,0-2.73-1.212-2.824-1.328v-6.154       c0-0.417,0.241-0.771,0.736-1.087c0.529-0.334,1.213-0.506,2.031-0.506c0.609,0,3.208-0.016,3.208,4.47       C1190.489,67.497,1190.283,70.577,1187.338,70.577 M1187.995,58.981c-2.328,0-3.337,0.984-3.666,1.291       c-0.611-1.444-2.692-1.012-2.692-1.012v19.372h2.877v-6.555c0.201,0.162,0.884,1.048,3.208,1.048c0.646,0,5.811,0,5.811-7.291       C1193.532,58.562,1187.995,58.981,1187.995,58.981"
}), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#SVGID_151_)",
  fill: "#4D4D4F",
  d: "M1148.558,59.182v7.889c0,3.438-1.582,6.054-5.659,6.054       c-4.078,0-5.659-2.616-5.659-6.054v-7.889c1.394-0.233,2.875,0.12,2.875,1.967h0.002v5.922c0,2.065,0.95,3.478,2.782,3.478       c1.833,0,2.782-1.412,2.782-3.478v-5.922h0.002C1145.683,59.302,1147.162,58.948,1148.558,59.182"
}), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#SVGID_151_)",
  fill: "#4D4D4F",
  d: "M1160.522,70.851l-0.002-5.923c0-2.063-0.948-3.479-2.781-3.479       c-1.832,0-2.781,1.415-2.781,3.479v5.923c0,1.848-1.483,2.198-2.878,1.965v-7.888c0-3.438,1.581-6.054,5.659-6.054       c4.077,0,5.661,2.615,5.661,6.054v7.888C1162.004,73.049,1160.522,72.698,1160.522,70.851"
}), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#SVGID_151_)",
  fill: "#EC1C24",
  d: "M1166.479,48.493c-4.78,0-8.668-3.89-8.668-8.668V24.502h-1.688       c-1.402,0-2.542-1.14-2.542-2.541v-6.412c0-1.402,1.14-2.543,2.542-2.543h15.297c1.402,0,2.541,1.141,2.541,2.543v6.412       c0,1.401-1.139,2.541-2.541,2.541h-1.609v11.975h13.009V24.502h-1.611c-1.399,0-2.54-1.14-2.54-2.541v-6.412       c0-1.402,1.141-2.543,2.54-2.543h15.3c1.4,0,2.54,1.141,2.54,2.543v6.412c0,1.401-1.14,2.541-2.54,2.541h-1.691v15.323       c0,4.778-3.886,8.668-8.667,8.668H1166.479z"
}), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#SVGID_151_)",
  fill: "#FFFFFF",
  d: "M1166.479,47.528c-4.248,0-7.703-3.455-7.703-7.702V23.537h-2.653       c-0.871,0-1.578-0.707-1.578-1.576v-6.412c0-0.871,0.707-1.576,1.578-1.576h15.297c0.871,0,1.578,0.705,1.578,1.576v6.412       c0,0.869-0.707,1.576-1.578,1.576h-2.574v13.135c0,0.422,0.346,0.77,0.771,0.77h13.396c0.425,0,0.771-0.348,0.771-0.77V23.537       h-2.575c-0.868,0-1.576-0.707-1.576-1.576v-6.412c0-0.871,0.708-1.576,1.576-1.576h15.3c0.869,0,1.574,0.705,1.574,1.576v6.412       c0,0.869-0.705,1.576-1.574,1.576h-2.653v16.289c0,4.247-3.458,7.702-7.705,7.702H1166.479z"
}));

var _ref98 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_152_",
  d: "M1181.209,14.936c-0.338,0-0.613,0.275-0.613,0.614v6.411c0,0.337,0.275,0.612,0.613,0.612h3.538v14.1         c0,0.953-0.779,1.734-1.734,1.734h-13.396c-0.954,0-1.735-0.781-1.735-1.734v-14.1h3.54c0.336,0,0.612-0.275,0.612-0.612V15.55         c0-0.339-0.276-0.614-0.612-0.614h-15.297c-0.339,0-0.614,0.275-0.614,0.614v6.411c0,0.337,0.275,0.612,0.614,0.612h3.617v17.254         c0,3.705,3.033,6.735,6.739,6.735h19.669c3.706,0,6.737-3.03,6.737-6.735V22.573h3.621c0.336,0,0.612-0.275,0.612-0.612V15.55         c0-0.339-0.276-0.614-0.612-0.614H1181.209z"
}));

var _ref99 = /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_153_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_152_",
  overflow: "visible"
}));

var _ref100 = /*#__PURE__*/React.createElement("rect", {
  x: 1155.51,
  y: 14.936,
  clipPath: "url(#SVGID_153_)",
  fill: "url(#SVGID_154_)",
  width: 41.61,
  height: 31.626
});

var _ref101 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#SVGID_2_)"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "SVGID_155_",
  x: -410,
  y: -501,
  width: 1920,
  height: 1080
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_156_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_155_",
  overflow: "visible"
})));

var _ref102 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#SVGID_2_)"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "SVGID_157_",
  x: -410,
  y: -501,
  width: 1920,
  height: 1080
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_158_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_157_",
  overflow: "visible"
})));

var _ref103 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#SVGID_2_)"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "SVGID_159_",
  x: -410,
  y: -501,
  width: 1920,
  height: 1080
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_160_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_159_",
  overflow: "visible"
})));

var SvgMarcas = function SvgMarcas(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    x: "0px",
    y: "0px",
    width: "1222px",
    height: "86px",
    viewBox: "0 0 1222 86",
    enableBackground: "new 0 0 1222 86",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", null, _ref2, _ref3, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_2_)"
  }, _ref4, _ref5, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: -410.0327,
    y1: 581.0332,
    x2: -409.0327,
    y2: 581.0332,
    gradientTransform: "matrix(-30.4732 30.4732 -30.4732 -30.4732 5645.6978 30208.1797)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCB31"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F05A22"
    }
  })), _ref6), _ref7, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_2_)"
  }, _ref8, _ref9, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: -409.9619,
    y1: 580.9619,
    x2: -408.9619,
    y2: 580.9619,
    gradientTransform: "matrix(26.2585 -26.2585 26.2585 26.2585 -3516.4905 -25978.9063)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EF4E37"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1444,
    style: {
      stopColor: "#EF5239"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2994,
    style: {
      stopColor: "#F15F40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4596,
    style: {
      stopColor: "#F3754B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6231,
    style: {
      stopColor: "#F6935B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7894,
    style: {
      stopColor: "#F9BA6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9556,
    style: {
      stopColor: "#FEE887"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF68E"
    }
  })), _ref10), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_2_)"
  }, _ref11, _ref12, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    clipPath: "url(#SVGID_12_)"
  }, /*#__PURE__*/React.createElement("g", null, _ref13, _ref14, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_14_)"
  }, _ref15, _ref16, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: -409.9995,
    y1: 580.9004,
    x2: -408.9995,
    y2: 580.9004,
    gradientTransform: "matrix(19.9154 0 0 19.9154 9142.5117 -11531.8535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F05B55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    style: {
      stopColor: "#F05B55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2326,
    style: {
      stopColor: "#EF4846"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#EC1C24"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EC1C24"
    }
  })), _ref17)))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_2_)"
  }, _ref18, _ref19, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: -410,
    y1: 580.9082,
    x2: -409,
    y2: 580.9082,
    gradientTransform: "matrix(21.6474 0 0 21.6474 9853.7383 -12526.9229)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EC1C24"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#EC1C24"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7674,
    style: {
      stopColor: "#EF4846"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    style: {
      stopColor: "#F05B55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F05B55"
    }
  })), _ref20), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_2_)"
  }, _ref21, _ref22, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: -409.959,
    y1: 580.959,
    x2: -408.959,
    y2: 580.959,
    gradientTransform: "matrix(24.3863 -24.3863 24.3863 24.3863 -3194.6677 -24131.1855)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EC1C24"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#EC1C24"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7674,
    style: {
      stopColor: "#EF4846"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    style: {
      stopColor: "#F05B55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F05B55"
    }
  })), _ref23), _ref24, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_2_)"
  }, _ref25, _ref26, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: -410,
    y1: 580.8984,
    x2: -409,
    y2: 580.8984,
    gradientTransform: "matrix(19.9243 0 0 19.9243 9146.167 -11540.8838)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F48B7C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    style: {
      stopColor: "#F48B7C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#F48776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#F27052"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F27052"
    }
  })), _ref27), _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_2_)"
  }, _ref41, _ref42, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_85_",
    gradientUnits: "userSpaceOnUse",
    x1: -402.2178,
    y1: 580.9258,
    x2: -401.2178,
    y2: 580.9258,
    gradientTransform: "matrix(26.9834 0 0 26.9834 11099.0205 -15671.1621)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00589F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7358,
    style: {
      stopColor: "#0071BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0071BB"
    }
  })), _ref43), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_2_)"
  }, _ref44, _ref45, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_88_",
    gradientUnits: "userSpaceOnUse",
    x1: -409.8569,
    y1: 595.999,
    x2: -408.8569,
    y2: 595.999,
    gradientTransform: "matrix(0 -14.0002 14.0002 0 -8080.979 -5701.48)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0531,
    style: {
      stopColor: "#EFFBFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3154,
    style: {
      stopColor: "#A6E7FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5506,
    style: {
      stopColor: "#6CD8F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7502,
    style: {
      stopColor: "#42CCF5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9064,
    style: {
      stopColor: "#28C6F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1FC3F3"
    }
  })), _ref46), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_2_)"
  }, _ref47, _ref48, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_91_",
    gradientUnits: "userSpaceOnUse",
    x1: -409.8193,
    y1: 595.9434,
    x2: -408.845,
    y2: 595.9434,
    gradientTransform: "matrix(0 -14.0524 14.0524 0 -8117.3813 -5722.7915)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009EDF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0455,
    style: {
      stopColor: "#02A0E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    style: {
      stopColor: "#17BAEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1FC3F3"
    }
  })), _ref49), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_2_)"
  }, _ref50, _ref51, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_94_",
    gradientUnits: "userSpaceOnUse",
    x1: -409.8574,
    y1: 595.9814,
    x2: -408.8574,
    y2: 595.9814,
    gradientTransform: "matrix(0 -14.0169 14.0169 0 -8091.3101 -5708.272)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0531,
    style: {
      stopColor: "#EFFBFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3154,
    style: {
      stopColor: "#A6E7FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5506,
    style: {
      stopColor: "#6CD8F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7502,
    style: {
      stopColor: "#42CCF5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9064,
    style: {
      stopColor: "#28C6F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1FC3F3"
    }
  })), _ref52), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_2_)"
  }, _ref53, _ref54, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_97_",
    gradientUnits: "userSpaceOnUse",
    x1: -409.8545,
    y1: 595.9951,
    x2: -408.8565,
    y2: 595.9951,
    gradientTransform: "matrix(0 -14.0041 14.0041 0 -8083.9297 -5703.0488)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0531,
    style: {
      stopColor: "#EFFBFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3154,
    style: {
      stopColor: "#A6E7FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5506,
    style: {
      stopColor: "#6CD8F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7502,
    style: {
      stopColor: "#42CCF5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9064,
    style: {
      stopColor: "#28C6F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1FC3F3"
    }
  })), _ref55), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_2_)"
  }, _ref56, _ref57, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_100_",
    gradientUnits: "userSpaceOnUse",
    x1: -409.8574,
    y1: 595.9648,
    x2: -408.8574,
    y2: 595.9648,
    gradientTransform: "matrix(0 -14.033 14.033 0 -8104.3682 -5714.8452)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009EDF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0455,
    style: {
      stopColor: "#02A0E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    style: {
      stopColor: "#17BAEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1FC3F3"
    }
  })), _ref58), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_2_)"
  }, _ref59, _ref60, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_103_",
    gradientUnits: "userSpaceOnUse",
    x1: -409.8584,
    y1: 595.8691,
    x2: -408.8584,
    y2: 595.8691,
    gradientTransform: "matrix(0 -14.1229 14.1229 0 -8162.9575 -5751.6255)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0531,
    style: {
      stopColor: "#EFFBFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3154,
    style: {
      stopColor: "#A6E7FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5506,
    style: {
      stopColor: "#6CD8F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7502,
    style: {
      stopColor: "#42CCF5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9064,
    style: {
      stopColor: "#28C6F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1FC3F3"
    }
  })), _ref61), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_2_)"
  }, _ref62, _ref63, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_106_",
    gradientUnits: "userSpaceOnUse",
    x1: -409.8569,
    y1: 595.9854,
    x2: -408.8569,
    y2: 595.9854,
    gradientTransform: "matrix(0 -14.0129 14.0129 0 -8099.0654 -5706.646)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0531,
    style: {
      stopColor: "#EFFBFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3154,
    style: {
      stopColor: "#A6E7FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5506,
    style: {
      stopColor: "#6CD8F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7502,
    style: {
      stopColor: "#42CCF5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9064,
    style: {
      stopColor: "#28C6F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1FC3F3"
    }
  })), _ref64), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_2_)"
  }, _ref65, _ref66, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_109_",
    gradientUnits: "userSpaceOnUse",
    x1: -409.8574,
    y1: 595.9785,
    x2: -408.8574,
    y2: 595.9785,
    gradientTransform: "matrix(0 -14.0188 14.0188 0 -8104.791 -5709.0698)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0531,
    style: {
      stopColor: "#EFFBFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3154,
    style: {
      stopColor: "#A6E7FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5506,
    style: {
      stopColor: "#6CD8F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7502,
    style: {
      stopColor: "#42CCF5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9064,
    style: {
      stopColor: "#28C6F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1FC3F3"
    }
  })), _ref67), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_2_)"
  }, _ref68, _ref69, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_112_",
    gradientUnits: "userSpaceOnUse",
    x1: -409.8574,
    y1: 596,
    x2: -408.8574,
    y2: 596,
    gradientTransform: "matrix(0 -14.0003 14.0003 0 -8093.1372 -5701.4863)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0531,
    style: {
      stopColor: "#EFFBFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3154,
    style: {
      stopColor: "#A6E7FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5506,
    style: {
      stopColor: "#6CD8F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7502,
    style: {
      stopColor: "#42CCF5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9064,
    style: {
      stopColor: "#28C6F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1FC3F3"
    }
  })), _ref70), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_2_)"
  }, _ref71, _ref72, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_115_",
    gradientUnits: "userSpaceOnUse",
    x1: -409.8574,
    y1: 595.9766,
    x2: -408.8574,
    y2: 595.9766,
    gradientTransform: "matrix(0 -14.0222 14.0222 0 -8108.2451 -5710.4512)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009EDF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0455,
    style: {
      stopColor: "#02A0E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    style: {
      stopColor: "#17BAEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1FC3F3"
    }
  })), _ref73), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_2_)"
  }, _ref74, _ref75, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_118_",
    gradientUnits: "userSpaceOnUse",
    x1: -200,
    y1: 41.1914,
    x2: -199,
    y2: 41.1914,
    gradientTransform: "matrix(8.470000e-004 0 0 8.470000e-004 -508.3397 754.5251)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0531,
    style: {
      stopColor: "#EFFBFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3154,
    style: {
      stopColor: "#A6E7FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5506,
    style: {
      stopColor: "#6CD8F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7502,
    style: {
      stopColor: "#42CCF5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9064,
    style: {
      stopColor: "#28C6F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1FC3F3"
    }
  })), _ref76), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_2_)"
  }, _ref77, _ref78, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_121_",
    gradientUnits: "userSpaceOnUse",
    x1: -410.0732,
    y1: 607.291,
    x2: -410.0732,
    y2: 607.291,
    gradientTransform: "matrix(0 -7.9872 7.9872 0 -4609.6499 -3234.1416)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009EDF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0455,
    style: {
      stopColor: "#02A0E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    style: {
      stopColor: "#17BAEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1FC3F3"
    }
  })), _ref79), _ref80, _ref81, _ref82, _ref83, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_2_)"
  }, _ref84, _ref85, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_138_",
    gradientUnits: "userSpaceOnUse",
    x1: -410,
    y1: 580.9473,
    x2: -409,
    y2: 580.9473,
    gradientTransform: "matrix(37.832 0 0 37.832 16101.6504 -21954.5684)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00ADEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4233,
    style: {
      stopColor: "#00ADEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#00589F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00589F"
    }
  })), _ref86), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_2_)"
  }, _ref87, _ref88, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_141_",
    gradientUnits: "userSpaceOnUse",
    x1: -410,
    y1: 580.9209,
    x2: -409,
    y2: 580.9209,
    gradientTransform: "matrix(25.5263 0 0 25.5263 11068.5977 -14802.3389)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00ADEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#00ADEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#00589F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00589F"
    }
  })), _ref89), _ref90, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_2_)"
  }, _ref91, _ref92, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_146_",
    gradientUnits: "userSpaceOnUse",
    x1: -409.9482,
    y1: 581,
    x2: -408.9482,
    y2: 581,
    gradientTransform: "matrix(0 -39.0849 39.0849 0 -21909.6914 -15977.0234)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0455A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6609,
    style: {
      stopColor: "#1585C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C99D6"
    }
  })), _ref93), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_2_)"
  }, _ref94, _ref95, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_149_",
    gradientUnits: "userSpaceOnUse",
    x1: -409.8833,
    y1: 581,
    x2: -408.8833,
    y2: 581,
    gradientTransform: "matrix(0 -17.1297 17.1297 0 -9153.668 -6999.4204)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#74BF44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A4CD39"
    }
  })), _ref96), _ref97, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_2_)"
  }, _ref98, _ref99, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_154_",
    gradientUnits: "userSpaceOnUse",
    x1: -409.937,
    y1: 581,
    x2: -408.937,
    y2: 581,
    gradientTransform: "matrix(0 -31.625 31.625 0 -17197.7969 -12917.6885)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#003371"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#007DC4"
    }
  })), _ref100), _ref101, _ref102, _ref103));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMarcas, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/marcas.1ad72916.svg";
export { ForwardRef as ReactComponent };